export interface ChordDefinition {
    positions: string[];
    fingerings: string[][];
}

export const CHORDS_DB: { [name: string]: ChordDefinition[]; } = {
    "A": [{
        "positions": ["5", "7", "7", "6", "5", "5"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "0", "7", "6", "5", "5"],
        "fingerings": [["0", "0", "3", "2", "1", "1"]]
    }, {
        "positions": ["x", "12", "11", "9", "10", "9"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {
        "positions": ["x", "12", "14", "14", "14", "12"],
        "fingerings": [["0", "1", "2", "3", "4", "1"], ["0", "1", "3", "3", "3", "1"]]
    }, {
        "positions": ["x", "0", "2", "2", "2", "0"],
        "fingerings": [["0", "0", "1", "2", "3", "0"], ["0", "0", "1", "1", "1", "0"], ["0", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["5", "4", "2", "2", "2", "5"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "7", "9", "10", "9"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Am": [{
        "positions": ["x", "0", "2", "2", "1", "0"],
        "fingerings": [["0", "0", "2", "3", "1", "0"]]
    }, {
        "positions": ["5", "7", "7", "5", "5", "5"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "0", "2", "5", "5", "5"],
        "fingerings": [["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "4", "4", "4"]]
    }, {
        "positions": ["x", "x", "7", "9", "10", "8"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "12", "14", "14", "13", "12"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {"positions": ["x", "x", "7", "5", "5", "5"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "A5": [{
        "positions": ["x", "0", "2", "2", "x", "x"],
        "fingerings": [["0", "0", "2", "3", "0", "0"], ["0", "0", "1", "2", "0", "0"], ["0", "0", "3", "4", "0", "0"]]
    }, {
        "positions": ["5", "7", "7", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"], ["1", "2", "3", "0", "0", "0"], ["1", "4", "4", "0", "0", "0"], ["1", "3", "3", "0", "0", "0"]]
    }, {
        "positions": ["x", "12", "14", "14", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "2", "5", "5"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "7", "9", "10", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Asus2": [{
        "positions": ["x", "0", "2", "2", "0", "0"],
        "fingerings": [["0", "0", "2", "3", "0", "0"], ["0", "0", "1", "2", "0", "0"], ["0", "0", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "12", "14", "14", "12", "12"],
        "fingerings": [["0", "1", "3", "4", "1", "1"], ["0", "1", "2", "3", "1", "1"]]
    }, {
        "positions": ["x", "12", "14", "16", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "7", "4", "5", "7"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "7", "9", "10", "7"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Asus4": [{
        "positions": ["x", "0", "2", "2", "3", "0"],
        "fingerings": [["0", "0", "1", "2", "3", "0"]]
    }, {
        "positions": ["5", "7", "7", "7", "5", "5"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "12", "12", "9", "10", "x"],
        "fingerings": [["0", "3", "4", "1", "2", "0"]]
    }, {
        "positions": ["x", "12", "14", "14", "15", "12"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "x", "7", "9", "10", "10"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "7", "7", "5", "5"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "A+": [{
        "positions": ["x", "12", "11", "10", "10", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "7", "6", "6", "5"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["5", "4", "3", "2", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["5", "8", "7", "6", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "12", "x", "14", "14", "13"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "A°": [{
        "positions": ["x", "12", "13", "14", "13", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["5", "x", "7", "5", "4", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["5", "6", "7", "5", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "A7": [{
        "positions": ["x", "0", "2", "0", "2", "0"],
        "fingerings": [["0", "0", "2", "0", "3", "0"]]
    }, {
        "positions": ["x", "0", "2", "2", "2", "3"],
        "fingerings": [["0", "0", "1", "1", "1", "2"], ["0", "0", "1", "1", "1", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["5", "7", "5", "6", "5", "5"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["5", "x", "5", "6", "5", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "0", "7", "9", "8", "9"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "12", "14", "12", "14", "12"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "7", "9", "8", "9"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "12", "11", "12", "10", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "A7sus4": [{
        "positions": ["x", "0", "2", "0", "3", "0"],
        "fingerings": [["0", "0", "1", "0", "3", "0"]]
    }, {
        "positions": ["x", "0", "2", "0", "3", "3"],
        "fingerings": [["0", "0", "1", "0", "3", "4"]]
    }, {
        "positions": ["5", "7", "5", "7", "5", "5"],
        "fingerings": [["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "12", "12", "12", "10", "10"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "12", "14", "12", "15", "12"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "7", "9", "8", "10"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Am7": [{
        "positions": ["x", "0", "2", "0", "1", "0"],
        "fingerings": [["0", "0", "2", "0", "1", "0"]]
    }, {
        "positions": ["x", "0", "2", "2", "1", "3"],
        "fingerings": [["0", "0", "2", "3", "1", "4"]]
    }, {
        "positions": ["5", "7", "5", "5", "5", "5"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["5", "0", "5", "5", "5", "0"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "12", "14", "12", "x", "12"],
        "fingerings": [["0", "1", "3", "1", "0", "1"], ["0", "1", "4", "1", "0", "1"]]
    }, {
        "positions": ["x", "12", "14", "12", "13", "12"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["5", "7", "7", "5", "8", "5"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["5", "x", "5", "5", "5", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "12", "10", "12", "13", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "12", "10", "12", "10", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "7", "9", "8", "8"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "AMaj7": [{
        "positions": ["x", "0", "2", "1", "2", "0"],
        "fingerings": [["0", "0", "2", "1", "3", "0"]]
    }, {
        "positions": ["x", "x", "7", "6", "5", "4"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "7", "9", "9", "9"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "4", "4", "4"]]
    }, {
        "positions": ["5", "x", "6", "6", "5", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "12", "14", "13", "14", "12"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {"positions": ["5", "7", "6", "6", "5", "5"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Am7b5": [{
        "positions": ["5", "x", "5", "5", "4", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "0", "1", "0", "1", "x"],
        "fingerings": [["0", "0", "1", "0", "2", "0"], ["0", "0", "1", "0", "3", "0"], ["0", "0", "2", "0", "4", "0"]]
    }, {
        "positions": ["5", "6", "7", "8", "8", "8"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "x", "7", "8", "8", "8"],
        "fingerings": [["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "12", "13", "12", "13", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "12", "x", "12", "13", "11"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["5", "6", "5", "5", "8", "5"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "A°7": [{
        "positions": ["x", "x", "7", "8", "7", "8"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["5", "x", "4", "5", "4", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "12", "13", "11", "13", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {"positions": ["x", "0", "1", "2", "1", "2"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "A+7": [{
        "positions": ["x", "12", "15", "12", "14", "13"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["5", "x", "5", "6", "6", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "7", "10", "8", "9"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "12", "x", "12", "14", "13"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "AmMaj7": [{
        "positions": ["x", "12", "14", "13", "13", "12"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["5", "x", "6", "5", "5", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["5", "7", "6", "5", "5", "5"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "7", "9", "9", "8"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "7", "5", "5", "4"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Aadd9": [{
        "positions": ["x", "0", "2", "4", "2", "0"],
        "fingerings": [["0", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "0", "7", "6", "0", "0"],
        "fingerings": [["0", "0", "2", "1", "0", "0"], ["0", "0", "3", "2", "0", "0"], ["0", "0", "4", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "7", "6", "5", "7"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "12", "14", "16", "14", "12"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["5", "x", "x", "6", "5", "7"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Amadd9": [{"positions": ["x", "x", "7", "5", "5", "7"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "A6": [{
        "positions": ["x", "0", "2", "2", "2", "2"],
        "fingerings": [["0", "0", "1", "1", "1", "1"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "0", "7", "9", "7", "9"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "x", "7", "6", "7", "5"],
        "fingerings": [["0", "0", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "0", "4", "2", "2", "0"],
        "fingerings": [["0", "0", "4", "1", "2", "0"], ["0", "0", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "0", "11", "11", "10", "0"],
        "fingerings": [["0", "0", "2", "3", "1", "0"], ["0", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "12", "14", "14", "14", "14"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "7", "9", "7", "9"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["5", "x", "4", "6", "5", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Am6": [{
        "positions": ["x", "0", "2", "2", "1", "2"],
        "fingerings": [["0", "0", "2", "3", "1", "4"]]
    }, {
        "positions": ["5", "7", "7", "5", "7", "0"],
        "fingerings": [["1", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "7", "9", "7", "8"],
        "fingerings": [["0", "0", "1", "3", "1", "2"]]
    }, {
        "positions": ["x", "12", "10", "11", "10", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["5", "x", "4", "5", "5", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["5", "7", "7", "5", "7", "5"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "12", "14", "11", "13", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "12", "10", "11", "10", "12"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "12", "x", "11", "13", "12"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Amb6": [{
        "positions": ["x", "12", "10", "10", "10", "12"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["5", "x", "3", "5", "5", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "A9": [{
        "positions": ["x", "0", "2", "4", "2", "3"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {
        "positions": ["x", "0", "5", "4", "5", "5"],
        "fingerings": [["0", "0", "2", "1", "3", "4"], ["0", "0", "2", "1", "3", "3"]]
    }, {
        "positions": ["x", "0", "5", "6", "5", "7"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"], ["0", "0", "1", "2", "1", "4"]]
    }, {
        "positions": ["5", "7", "5", "6", "5", "7"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "12", "11", "12", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "12", "11", "12", "12", "12"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["5", "x", "5", "4", "2", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "7", "6", "8", "7"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["5", "4", "5", "4", "5", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "A11": [{
        "positions": ["x", "0", "0", "0", "0", "0"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["5", "7", "5", "7", "5", "7"],
        "fingerings": [["1", "2", "1", "3", "1", "4"]]
    }, {
        "positions": ["x", "0", "5", "4", "3", "3"],
        "fingerings": [["0", "0", "3", "2", "1", "1"], ["0", "0", "4", "3", "1", "2"]]
    }, {
        "positions": ["x", "12", "12", "12", "12", "12"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "12", "11", "12", "10", "10"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "12", "12", "12", "14", "12"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "7", "7", "8", "9"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "A13": [{
        "positions": ["x", "0", "5", "4", "2", "2"],
        "fingerings": [["0", "0", "4", "3", "1", "1"]]
    }, {
        "positions": ["5", "x", "5", "6", "7", "7"],
        "fingerings": [["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "12", "11", "12", "12", "14"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["5", "x", "5", "4", "2", "2"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {"positions": ["5", "7", "5", "6", "7", "5"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "A9sus4": [{
        "positions": ["x", "12", "12", "12", "12", "12"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["5", "x", "5", "4", "3", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["5", "x", "5", "4", "3", "3"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "A13sus4": [{
        "positions": ["x", "12", "12", "12", "12", "14"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["5", "x", "5", "7", "7", "7"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Am9": [{
        "positions": ["5", "3", "5", "4", "x", "x"],
        "fingerings": [["3", "1", "4", "2", "0", "0"]]
    }, {
        "positions": ["x", "x", "7", "9", "8", "7"],
        "fingerings": [["0", "0", "1", "3", "2", "1"]]
    }, {
        "positions": ["5", "7", "5", "5", "5", "7"],
        "fingerings": [["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "12", "10", "12", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "12", "10", "12", "12", "12"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "7", "5", "8", "7"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["5", "x", "5", "5", "5", "7"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Am11": [{
        "positions": ["x", "12", "10", "12", "10", "10"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "12", "12", "12", "13", "12"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["5", "x", "5", "5", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "7", "7", "8", "8"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "12", "x", "12", "13", "10"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Am13": [{
        "positions": ["x", "12", "x", "12", "13", "14"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["5", "7", "5", "5", "7", "5"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["5", "x", "5", "5", "7", "7"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "12", "14", "12", "13", "14"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "12", "10", "12", "12", "14"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "AmMaj9": [{
        "positions": ["x", "12", "10", "13", "12", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["5", "7", "6", "5", "5", "7"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "AMaj9": [{
        "positions": ["x", "12", "11", "13", "12", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "7", "6", "9", "7"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "12", "9", "9", "9", "9"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["5", "4", "6", "4", "5", "4"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["5", "x", "6", "4", "5", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "AMaj13": [{
        "positions": ["x", "12", "x", "13", "14", "14"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["5", "4", "4", "4", "5", "4"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["5", "x", "6", "6", "7", "7"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "A+9": [{
        "positions": ["x", "12", "11", "12", "12", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["5", "x", "5", "6", "6", "7"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "AMaj7#11": [{
        "positions": ["x", "12", "13", "13", "14", "12"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["5", "x", "6", "6", "4", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "7", "8", "9", "9"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "A9b5": [{
        "positions": ["x", "12", "11", "12", "12", "11"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["5", "4", "5", "4", "4", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "A7b9": [{
        "positions": ["x", "12", "11", "12", "11", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["5", "7", "5", "6", "5", "6"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "12", "11", "12", "11", "12"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "7", "6", "8", "6"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "A7#9": [{
        "positions": ["x", "12", "11", "12", "13", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["5", "7", "5", "6", "5", "8"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "7", "6", "8", "8"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "A7b5#9": [{"positions": ["x", "12", "11", "12", "13", "11"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "A7#11": [{"positions": ["5", "6", "5", "6", "5", "5"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "A7b5": [{
        "positions": ["x", "12", "13", "12", "14", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["5", "x", "5", "6", "4", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "7", "8", "8", "9"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "12", "13", "12", "14", "15"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Am9b5": [{"positions": ["5", "6", "5", "5", "8", "7"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "A+7b9": [{
        "positions": ["x", "12", "11", "12", "11", "13"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["5", "x", "5", "6", "6", "6"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "A+7#9": [{
        "positions": ["x", "12", "11", "12", "13", "13"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["5", "x", "5", "6", "6", "8"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "B": [{
        "positions": ["x", "2", "4", "4", "4", "2"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "9", "9", "8", "7", "7"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "12", "11"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "14", "13", "11", "12", "11"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {"positions": ["7", "6", "4", "4", "4", "7"], "fingerings": [["3", "2", "1", "1", "1", "4"]]}],
    "Bm": [{
        "positions": ["x", "2", "4", "4", "3", "2"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["7", "9", "9", "7", "7", "7"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "12", "10"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "9", "7", "7", "7"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "B5": [{
        "positions": ["x", "2", "4", "4", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["7", "9", "9", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "4", "7", "7"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "9", "11", "12", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Bsus2": [{
        "positions": ["x", "2", "4", "4", "2", "2"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["7", "4", "4", "6", "0", "x"],
        "fingerings": [["4", "1", "2", "3", "0", "0"]]
    }, {
        "positions": ["x", "2", "4", "6", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "9", "6", "7", "9"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "9", "11", "12", "9"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Bsus4": [{
        "positions": ["x", "2", "4", "4", "5", "2"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "9", "9", "9", "7", "7"],
        "fingerings": [["1", "3", "3", "3", "1", "1"], ["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "12", "12"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "9", "9", "7", "7"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "B+": [{
        "positions": ["x", "14", "13", "12", "12", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "9", "8", "8", "7"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["7", "6", "5", "4", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["7", "10", "9", "8", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "2", "x", "4", "4", "3"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "B°": [{
        "positions": ["x", "2", "3", "4", "3", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["7", "x", "9", "7", "6", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["7", "8", "9", "7", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "B7": [{
        "positions": ["x", "x", "9", "11", "10", "11"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "2", "1", "2", "0", "2"],
        "fingerings": [["0", "2", "1", "3", "0", "4"]]
    }, {
        "positions": ["x", "2", "4", "2", "4", "2"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "7"],
        "fingerings": [["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "8", "7"],
        "fingerings": [["1", "0", "2", "2", "4", "3"]]
    }, {
        "positions": ["x", "14", "13", "14", "12", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["7", "x", "7", "8", "7", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "B7sus4": [{
        "positions": ["x", "2", "2", "2", "0", "0"],
        "fingerings": [["0", "1", "2", "3", "0", "0"], ["0", "2", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "2", "4", "4", "5", "2"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "9", "7", "9", "7", "7"],
        "fingerings": [["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "14", "14", "14", "12", "12"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "4", "2", "5", "2"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "9", "11", "10", "12"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Bm7": [{
        "positions": ["x", "2", "0", "2", "0", "2"],
        "fingerings": [["0", "1", "0", "3", "0", "4"], ["0", "2", "0", "3", "0", "4"]]
    }, {
        "positions": ["x", "2", "4", "2", "3", "2"],
        "fingerings": [["0", "1", "3", "1", "2", "1"]]
    }, {
        "positions": ["7", "9", "7", "7", "7", "7"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "7", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "2", "0", "2", "3", "x"],
        "fingerings": [["0", "1", "0", "2", "3", "0"], ["0", "2", "0", "3", "4", "0"], ["0", "1", "0", "3", "4", "0"]]
    }, {
        "positions": ["7", "9", "9", "7", "10", "7"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "14", "12", "14", "15", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "14", "12", "14", "12", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "9", "11", "10", "10"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "BMaj7": [{
        "positions": ["x", "2", "4", "3", "4", "2"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "9", "8", "7", "6"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "11", "11"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["7", "x", "8", "8", "7", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["7", "9", "8", "8", "7", "7"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Bm7b5": [{
        "positions": ["x", "x", "9", "10", "10", "10"],
        "fingerings": [["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["7", "x", "7", "7", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "2", "3", "2", "3", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["7", "8", "9", "10", "10", "10"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "2", "x", "2", "3", "1"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["7", "8", "7", "7", "10", "7"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "B°7": [{
        "positions": ["x", "2", "3", "1", "3", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["7", "8", "6", "7", "x", "x"],
        "fingerings": [["2", "4", "1", "3", "0", "0"]]
    }, {
        "positions": ["7", "x", "6", "7", "6", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "9", "10"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "B+7": [{
        "positions": ["x", "2", "5", "2", "4", "3"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["7", "x", "7", "8", "8", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "9", "12", "10", "11"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "2", "x", "2", "4", "3"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "BmMaj7": [{
        "positions": ["x", "2", "4", "3", "3", "2"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["7", "x", "8", "7", "7", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["7", "9", "8", "7", "7", "7"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "11", "10"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "9", "7", "7", "6"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Badd9": [{
        "positions": ["x", "2", "4", "4", "2", "2"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "8", "7", "9"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "2", "4", "6", "4", "2"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["7", "x", "x", "8", "7", "9"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Bmadd9": [{"positions": ["x", "x", "9", "7", "7", "9"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "B6": [{
        "positions": ["x", "2", "1", "1", "0", "2"],
        "fingerings": [["0", "3", "1", "2", "0", "4"]]
    }, {
        "positions": ["x", "2", "4", "4", "4", "4"],
        "fingerings": [["0", "1", "3", "3", "3", "3"], ["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "9", "11", "9", "11"],
        "fingerings": [["0", "0", "1", "3", "1", "4"]]
    }, {
        "positions": ["x", "x", "9", "8", "9", "7"],
        "fingerings": [["0", "0", "3", "2", "4", "1"]]
    }, {"positions": ["7", "x", "6", "8", "7", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Bm6": [{
        "positions": ["x", "2", "0", "1", "0", "x"],
        "fingerings": [["0", "3", "0", "1", "0", "0"], ["0", "2", "0", "1", "0", "0"]]
    }, {
        "positions": ["7", "9", "9", "7", "9", "7"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "9", "10"],
        "fingerings": [["0", "0", "1", "3", "1", "2"]]
    }, {
        "positions": ["x", "2", "4", "1", "3", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["7", "x", "6", "7", "7", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "14", "12", "13", "12", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "14", "12", "13", "12", "14"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "2", "x", "1", "3", "2"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Bmb6": [{
        "positions": ["x", "14", "12", "12", "12", "14"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["7", "x", "5", "7", "7", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "B9": [{
        "positions": ["x", "2", "1", "2", "2", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "9"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["7", "x", "7", "6", "7", "7"],
        "fingerings": [["2", "0", "3", "1", "4", "4"]]
    }, {
        "positions": ["x", "2", "1", "2", "2", "2"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["7", "x", "7", "6", "4", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "8", "10", "9"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["7", "6", "7", "6", "7", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "B11": [{
        "positions": ["x", "2", "2", "2", "2", "2"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["7", "9", "7", "9", "7", "9"],
        "fingerings": [["1", "2", "1", "3", "1", "4"]]
    }, {
        "positions": ["7", "x", "7", "6", "5", "5"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "14", "13", "14", "12", "12"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "2", "2", "4", "2"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "9", "9", "10", "11"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "B13": [{
        "positions": ["7", "x", "7", "6", "4", "4"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["7", "x", "7", "8", "9", "9"],
        "fingerings": [["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "2", "1", "2", "2", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["7", "9", "7", "8", "9", "7"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "B9sus4": [{
        "positions": ["x", "2", "2", "2", "2", "2"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["7", "x", "7", "6", "5", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["7", "x", "7", "6", "5", "5"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "B13sus4": [{
        "positions": ["x", "2", "2", "2", "2", "4"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["7", "x", "7", "9", "9", "9"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Bm9": [{
        "positions": ["x", "2", "0", "2", "2", "x"],
        "fingerings": [["0", "2", "0", "3", "4", "0"], ["0", "1", "0", "2", "3", "0"], ["0", "1", "0", "3", "4", "0"]]
    }, {
        "positions": ["7", "9", "7", "7", "7", "9"],
        "fingerings": [["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "14", "12", "14", "14", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "14", "12", "14", "14", "14"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "9", "7", "10", "9"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["7", "x", "7", "7", "7", "9"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Bm11": [{
        "positions": ["x", "14", "12", "14", "12", "12"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "2", "2", "3", "2"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "9", "10", "10"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "14", "x", "14", "15", "12"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Bm13": [{
        "positions": ["x", "2", "x", "2", "3", "4"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["7", "9", "7", "7", "9", "7"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "9", "9"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "2", "4", "2", "3", "4"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "14", "12", "14", "14", "16"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "BmMaj9": [{
        "positions": ["x", "14", "12", "15", "14", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["7", "9", "8", "7", "7", "9"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "BMaj9": [{
        "positions": ["x", "2", "1", "3", "2", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "9", "8", "11", "9"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "14", "11", "11", "11", "11"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["7", "6", "8", "6", "7", "6"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["7", "x", "8", "6", "7", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "BMaj13": [{
        "positions": ["x", "2", "x", "3", "4", "4"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["7", "6", "6", "6", "7", "6"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["7", "x", "8", "8", "9", "9"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "B+9": [{
        "positions": ["x", "2", "1", "2", "2", "3"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["7", "x", "7", "8", "8", "9"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "BMaj7#11": [{
        "positions": ["x", "2", "3", "3", "4", "2"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "x", "8", "8", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "11", "11"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "B9b5": [{
        "positions": ["x", "2", "1", "2", "2", "1"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["7", "6", "7", "6", "6", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "B7b9": [{
        "positions": ["x", "2", "1", "2", "1", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "8"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "2", "1", "2", "1", "2"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "9", "8", "10", "8"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "B7#9": [{
        "positions": ["x", "2", "1", "2", "3", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "10"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "9", "8", "10", "10"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "B7b5#9": [{"positions": ["x", "2", "1", "2", "3", "1"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "B7#11": [{"positions": ["7", "8", "7", "8", "7", "7"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "B7b5": [{
        "positions": ["x", "2", "3", "2", "4", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["7", "x", "7", "8", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "10", "11"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "2", "3", "2", "4", "5"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Bm9b5": [{"positions": ["7", "8", "7", "7", "10", "9"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "B+7b9": [{
        "positions": ["x", "2", "1", "2", "1", "3"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["7", "x", "7", "8", "8", "8"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "B+7#9": [{
        "positions": ["x", "2", "1", "2", "3", "3"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["7", "x", "7", "8", "8", "10"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "C": [{
        "positions": ["x", "3", "2", "0", "1", "0"],
        "fingerings": [["0", "3", "2", "0", "1", "0"]]
    }, {
        "positions": ["x", "3", "5", "5", "5", "3"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["8", "10", "10", "9", "8", "8"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["8", "7", "5", "5", "5", "8"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "10", "12", "13", "12"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Cm": [{
        "positions": ["x", "3", "5", "5", "4", "3"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["8", "10", "10", "8", "8", "8"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "8", "8", "8"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "10", "12", "13", "11"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "C5": [{
        "positions": ["8", "10", "10", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "3", "5", "5", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "5", "8", "8"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "10", "12", "13", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Csus2": [{
        "positions": ["x", "3", "0", "0", "1", "3"],
        "fingerings": [["0", "3", "0", "0", "1", "4"]]
    }, {
        "positions": ["x", "3", "5", "5", "3", "3"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "5", "7", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "10", "7", "8", "10"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "10", "12", "13", "10"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Csus4": [{
        "positions": ["x", "3", "3", "0", "1", "1"],
        "fingerings": [["0", "3", "4", "0", "1", "1"]]
    }, {
        "positions": ["x", "3", "5", "5", "6", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["8", "10", "10", "10", "8", "8"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "13", "13"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "10", "10", "8", "8"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "C+": [{
        "positions": ["x", "3", "2", "1", "1", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "9", "8"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["8", "7", "6", "5", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["8", "11", "10", "9", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "3", "x", "5", "5", "4"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "C°": [{
        "positions": ["x", "3", "4", "5", "4", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["8", "x", "10", "8", "7", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["8", "9", "10", "8", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "C7": [{
        "positions": ["x", "3", "2", "3", "1", "0"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {
        "positions": ["x", "3", "5", "3", "5", "3"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "8"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "11", "12"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "3", "2", "3", "1", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["8", "x", "8", "9", "8", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "C7sus4": [{
        "positions": ["x", "3", "3", "3", "1", "1"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "5", "3", "6", "3"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["8", "10", "8", "10", "8", "8"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "10", "12", "11", "13"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Cm7": [{
        "positions": ["x", "3", "5", "3", "4", "3"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["8", "10", "10", "8", "11", "8"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["8", "x", "8", "8", "8", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "3", "1", "3", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["8", "10", "8", "8", "8", "8"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "3", "1", "3", "1", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "10", "12", "11", "11"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "CMaj7": [{
        "positions": ["x", "3", "2", "0", "0", "0"],
        "fingerings": [["0", "3", "2", "0", "0", "0"], ["0", "2", "1", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "8", "7"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "3", "5", "4", "5", "3"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["8", "x", "9", "9", "8", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "12", "12", "12"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {"positions": ["8", "10", "9", "9", "8", "8"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Cm7b5": [{
        "positions": ["x", "3", "4", "3", "4", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["8", "x", "8", "8", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "11", "11"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["8", "9", "10", "11", "11", "11"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "3", "x", "3", "4", "2"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["8", "9", "8", "8", "11", "8"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "C°7": [{
        "positions": ["x", "3", "4", "2", "4", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["8", "x", "7", "8", "7", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "10", "11"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "C+7": [{
        "positions": ["x", "3", "6", "3", "5", "4"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["8", "x", "8", "9", "9", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "10", "13", "11", "12"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "3", "x", "3", "5", "4"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "CmMaj7": [{
        "positions": ["x", "3", "1", "0", "0", "3"],
        "fingerings": [["0", "3", "1", "0", "0", "4"]]
    }, {
        "positions": ["x", "3", "5", "4", "4", "3"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["8", "x", "9", "8", "8", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["8", "10", "9", "8", "8", "8"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "12", "11"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "10", "8", "8", "7"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Cadd9": [{
        "positions": ["x", "3", "2", "0", "3", "0"],
        "fingerings": [["0", "2", "1", "0", "3", "0"], ["0", "2", "1", "0", "4", "0"], ["0", "3", "2", "0", "4", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "8", "10"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "3", "2", "0", "3", "3"],
        "fingerings": [["0", "2", "1", "0", "3", "4"]]
    }, {
        "positions": ["x", "3", "5", "7", "5", "3"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["8", "x", "x", "9", "8", "10"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Cmadd9": [{
        "positions": ["x", "3", "1", "0", "3", "3"],
        "fingerings": [["0", "2", "1", "0", "3", "4"], ["0", "2", "1", "0", "4", "4"]]
    }, {"positions": ["x", "x", "10", "8", "8", "10"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "C6": [{
        "positions": ["x", "3", "5", "5", "5", "5"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "10", "12", "10", "12"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["8", "x", "7", "9", "8", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Cm6": [{
        "positions": ["x", "3", "1", "2", "1", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["8", "10", "10", "8", "10", "8"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "10", "11"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "3", "5", "2", "4", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "3", "1", "2", "1", "3"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["8", "x", "7", "8", "8", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "3", "x", "2", "4", "3"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Cmb6": [{
        "positions": ["x", "3", "1", "1", "1", "3"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["8", "x", "6", "8", "8", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "C9": [{
        "positions": ["x", "3", "2", "3", "3", "0"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "10"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "3", "2", "3", "3", "3"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["8", "x", "8", "7", "5", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "11", "10"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["8", "7", "8", "7", "8", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "C11": [{
        "positions": ["x", "3", "2", "3", "1", "1"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "3", "3", "5", "3"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "10", "10", "11", "12"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "C13": [{
        "positions": ["x", "3", "2", "3", "3", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["8", "x", "8", "7", "5", "5"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["8", "x", "8", "9", "10", "10"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["8", "10", "8", "9", "10", "8"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "C9sus4": [{
        "positions": ["x", "3", "0", "3", "3", "1"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {
        "positions": ["x", "3", "3", "3", "3", "3"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["8", "x", "8", "7", "6", "6"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {"positions": ["8", "x", "8", "7", "6", "x"], "fingerings": [["3", "0", "4", "2", "1", "0"]]}],
    "C13sus4": [{
        "positions": ["x", "3", "3", "3", "3", "5"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["8", "x", "8", "10", "10", "10"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Cm9": [{
        "positions": ["8", "10", "8", "8", "8", "10"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "3", "1", "3", "3", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "3", "1", "3", "3", "3"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "10", "8", "11", "10"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["8", "x", "8", "8", "8", "10"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Cm11": [{
        "positions": ["x", "3", "1", "3", "1", "1"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "3", "3", "4", "3"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["8", "x", "8", "8", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "10", "11", "11"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "3", "x", "3", "4", "1"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Cm13": [{
        "positions": ["x", "3", "x", "3", "4", "5"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["8", "10", "8", "8", "10", "8"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["8", "x", "8", "8", "10", "10"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "3", "1", "3", "3", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["x", "3", "5", "3", "4", "5"], "fingerings": [["0", "1", "3", "1", "2", "4"]]}],
    "CmMaj9": [{
        "positions": ["x", "3", "1", "4", "3", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["8", "10", "9", "8", "8", "10"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "CMaj9": [{
        "positions": ["x", "3", "2", "4", "3", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "12", "10"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "15", "12", "12", "12", "12"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["8", "7", "9", "7", "8", "7"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["8", "x", "9", "7", "8", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "CMaj13": [{
        "positions": ["x", "3", "x", "4", "5", "5"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["8", "7", "7", "7", "8", "7"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {
        "positions": ["8", "x", "9", "9", "10", "10"],
        "fingerings": [["1", "0", "2", "3", "4", "4"]]
    }, {"positions": ["x", "3", "2", "2", "0", "0"], "fingerings": [["0", "3", "1", "2", "0", "0"]]}],
    "C+9": [{
        "positions": ["x", "3", "2", "3", "3", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["8", "x", "8", "9", "9", "10"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "CMaj7#11": [{
        "positions": ["x", "3", "2", "0", "0", "2"],
        "fingerings": [["0", "3", "1", "0", "0", "2"]]
    }, {
        "positions": ["x", "3", "4", "4", "5", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["8", "x", "9", "9", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "12", "12"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "C9b5": [{
        "positions": ["x", "3", "2", "3", "3", "2"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["8", "7", "8", "7", "7", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "C7b9": [{
        "positions": ["x", "3", "2", "3", "2", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "9"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "3", "2", "3", "2", "3"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "10", "9", "11", "9"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "C7#9": [{
        "positions": ["x", "3", "2", "3", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "11"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "10", "9", "11", "11"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "C7b5#9": [{"positions": ["x", "3", "2", "3", "4", "2"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "C7#11": [{"positions": ["8", "9", "8", "9", "8", "8"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "C7b5": [{
        "positions": ["x", "3", "4", "3", "5", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["8", "x", "8", "9", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "11", "12"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "3", "4", "3", "5", "6"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Cm9b5": [{"positions": ["8", "9", "8", "8", "11", "10"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "C+7b9": [{
        "positions": ["x", "3", "2", "3", "2", "4"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["8", "x", "8", "9", "9", "9"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "C+7#9": [{
        "positions": ["x", "3", "2", "3", "4", "4"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["8", "x", "8", "9", "9", "11"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "D": [{
        "positions": ["x", "x", "0", "2", "3", "2"],
        "fingerings": [["0", "0", "0", "1", "3", "2"]]
    }, {
        "positions": ["x", "5", "7", "7", "7", "5"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["10", "12", "12", "11", "10", "10"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "5", "4", "2", "3", "2"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {
        "positions": ["10", "9", "7", "7", "7", "10"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "12", "14", "15", "14"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Dm": [{
        "positions": ["x", "x", "0", "2", "3", "1"],
        "fingerings": [["0", "0", "0", "2", "3", "1"]]
    }, {
        "positions": ["x", "5", "7", "7", "6", "5"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["10", "12", "12", "10", "10", "10"],
        "fingerings": [["1", "2", "3", "1", "1", "1"], ["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "12", "10", "10", "10"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "12", "14", "15", "13"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "D5": [{
        "positions": ["x", "5", "7", "7", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "0", "2", "3", "x"],
        "fingerings": [["0", "0", "0", "1", "2", "0"], ["0", "0", "0", "2", "3", "0"], ["0", "0", "0", "3", "4", "0"]]
    }, {
        "positions": ["10", "12", "12", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "7", "10", "10"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "12", "14", "15", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Dsus2": [{
        "positions": ["x", "x", "0", "2", "3", "0"],
        "fingerings": [["0", "0", "0", "2", "3", "0"], ["0", "0", "0", "1", "2", "0"]]
    }, {
        "positions": ["x", "5", "7", "7", "5", "5"],
        "fingerings": [["0", "1", "2", "3", "1", "1"], ["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "5", "7", "9", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "12", "9", "10", "12"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "12", "14", "15", "12"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Dsus4": [{
        "positions": ["x", "x", "0", "2", "3", "3"],
        "fingerings": [["0", "0", "0", "2", "3", "4"], ["0", "0", "0", "1", "2", "3"]]
    }, {
        "positions": ["x", "5", "7", "7", "8", "5"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["10", "12", "12", "12", "10", "10"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "5", "5", "2", "3", "x"],
        "fingerings": [["0", "3", "4", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "12", "14", "15", "15"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "12", "12", "10", "10"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "D+": [{
        "positions": ["x", "5", "4", "3", "3", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "12", "11", "11", "10"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["10", "9", "8", "7", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["10", "13", "12", "11", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "5", "x", "7", "7", "6"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "D°": [{
        "positions": ["x", "5", "6", "7", "6", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["10", "x", "12", "10", "9", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["10", "11", "12", "10", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "D7": [{
        "positions": ["x", "x", "0", "2", "1", "2"],
        "fingerings": [["0", "0", "0", "2", "1", "3"]]
    }, {
        "positions": ["x", "5", "7", "5", "7", "5"],
        "fingerings": [["0", "1", "3", "1", "4", "1"], ["0", "1", "2", "1", "3", "1"]]
    }, {
        "positions": ["10", "12", "10", "11", "10", "10"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["10", "x", "10", "11", "10", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "5", "4", "5", "3", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["x", "x", "12", "14", "13", "14"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "D7sus4": [{
        "positions": ["x", "x", "0", "2", "1", "3"],
        "fingerings": [["0", "0", "0", "2", "1", "3"], ["0", "0", "0", "2", "1", "4"], ["0", "0", "0", "3", "2", "4"]]
    }, {
        "positions": ["x", "5", "5", "5", "3", "3"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "5", "7", "5", "8", "5"],
        "fingerings": [["0", "1", "2", "1", "3", "1"], ["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["10", "12", "10", "12", "10", "10"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "12", "14", "13", "15"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Dm7": [{
        "positions": ["x", "x", "0", "2", "1", "1"],
        "fingerings": [["0", "0", "0", "2", "1", "1"], ["0", "0", "0", "3", "1", "2"]]
    }, {
        "positions": ["x", "5", "7", "5", "6", "5"],
        "fingerings": [["0", "1", "3", "1", "2", "1"]]
    }, {
        "positions": ["10", "12", "10", "10", "10", "10"],
        "fingerings": [["1", "2", "1", "1", "1", "1"], ["1", "3", "1", "1", "1", "1"], ["1", "4", "0", "0", "0", "0"]]
    }, {
        "positions": ["10", "x", "10", "10", "10", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["10", "12", "12", "10", "13", "10"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "5", "3", "5", "6", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "5", "3", "5", "3", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "12", "14", "13", "13"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "DMaj7": [{
        "positions": ["x", "x", "0", "2", "2", "2"],
        "fingerings": [["0", "0", "0", "1", "1", "1"], ["0", "0", "0", "1", "2", "3"], ["0", "0", "0", "2", "3", "4"]]
    }, {
        "positions": ["x", "5", "7", "6", "7", "5"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "12", "11", "10", "9"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "12", "14", "14", "14"],
        "fingerings": [["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "5", "4", "2", "2", "x"],
        "fingerings": [["0", "3", "2", "1", "1", "0"], ["0", "4", "3", "1", "1", "0"]]
    }, {
        "positions": ["10", "x", "11", "11", "10", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["10", "12", "11", "11", "10", "10"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Dm7b5": [{
        "positions": ["x", "x", "0", "1", "1", "1"],
        "fingerings": [["0", "0", "0", "1", "1", "1"], ["0", "0", "0", "1", "2", "3"], ["0", "0", "0", "2", "3", "4"]]
    }, {
        "positions": ["x", "5", "6", "5", "6", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["10", "x", "10", "10", "9", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["10", "11", "12", "13", "13", "13"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "x", "12", "13", "13", "13"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "5", "x", "5", "6", "4"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["10", "11", "10", "10", "13", "10"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "D°7": [{
        "positions": ["x", "x", "0", "1", "0", "1"],
        "fingerings": [["0", "0", "0", "1", "0", "2"], ["0", "0", "0", "2", "0", "3"], ["0", "0", "0", "3", "0", "4"]]
    }, {
        "positions": ["x", "5", "6", "4", "6", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["10", "x", "9", "10", "9", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "12", "13", "12", "13"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "D+7": [{
        "positions": ["x", "5", "8", "5", "7", "6"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["10", "x", "10", "11", "11", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "12", "15", "13", "14"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "5", "x", "5", "7", "6"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "DmMaj7": [{
        "positions": ["x", "5", "7", "6", "6", "5"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["10", "x", "11", "10", "10", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["10", "12", "11", "10", "10", "10"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "12", "14", "14", "13"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "12", "10", "10", "9"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Dadd9": [{
        "positions": ["x", "5", "4", "2", "3", "0"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "10", "12"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "5", "7", "7", "5", "5"],
        "fingerings": [["0", "1", "2", "3", "1", "1"], ["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "12", "11", "10", "12"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "5", "7", "9", "7", "5"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["10", "x", "x", "11", "10", "12"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Dmadd9": [{"positions": ["x", "x", "12", "10", "10", "12"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "D6": [{
        "positions": ["x", "x", "0", "2", "0", "2"],
        "fingerings": [["0", "0", "0", "2", "0", "3"], ["0", "0", "0", "1", "0", "2"], ["0", "0", "0", "3", "0", "4"]]
    }, {
        "positions": ["x", "5", "7", "7", "7", "7"],
        "fingerings": [["0", "1", "2", "3", "4", "4"], ["0", "1", "3", "3", "3", "3"]]
    }, {
        "positions": ["0", "0", "12", "11", "12", "10"],
        "fingerings": [["0", "0", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "12", "14", "12", "14"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["10", "x", "9", "11", "10", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Dm6": [{
        "positions": ["x", "x", "0", "2", "0", "1"],
        "fingerings": [["0", "0", "0", "2", "0", "1"]]
    }, {
        "positions": ["10", "12", "12", "10", "12", "10"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "5", "3", "4", "3", "x"],
        "fingerings": [["0", "4", "1", "2", "1", "0"], ["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "x", "12", "14", "12", "13"],
        "fingerings": [["0", "0", "1", "3", "1", "2"]]
    }, {
        "positions": ["x", "5", "7", "4", "6", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "5", "3", "4", "3", "5"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["10", "x", "9", "10", "10", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "5", "x", "4", "6", "5"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Dmb6": [{
        "positions": ["x", "5", "3", "3", "3", "5"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["10", "x", "8", "10", "10", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "D9": [{
        "positions": ["x", "x", "0", "2", "1", "0"],
        "fingerings": [["0", "0", "0", "2", "1", "0"], ["0", "0", "0", "3", "2", "0"], ["0", "0", "0", "4", "3", "0"]]
    }, {
        "positions": ["x", "5", "4", "5", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["10", "12", "10", "11", "10", "12"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["10", "x", "10", "9", "10", "10"],
        "fingerings": [["2", "0", "3", "1", "4", "4"]]
    }, {
        "positions": ["x", "5", "4", "5", "5", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["10", "x", "10", "9", "7", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "12", "11", "13", "12"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["10", "9", "10", "9", "10", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "D11": [{
        "positions": ["x", "5", "5", "5", "5", "5"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["10", "x", "10", "9", "8", "8"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "0", "5", "5", "3"],
        "fingerings": [["0", "0", "0", "3", "4", "1"], ["0", "0", "0", "2", "3", "1"]]
    }, {
        "positions": ["x", "5", "4", "5", "3", "3"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "5", "5", "5", "7", "5"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "12", "12", "13", "14"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "D13": [{
        "positions": ["10", "x", "10", "9", "7", "7"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "5", "4", "5", "5", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["10", "x", "10", "11", "12", "12"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["10", "12", "10", "11", "12", "10"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "D9sus4": [{
        "positions": ["x", "5", "5", "5", "5", "5"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["10", "x", "10", "9", "8", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["10", "x", "10", "9", "8", "8"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "D13sus4": [{
        "positions": ["x", "5", "5", "5", "5", "7"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["10", "x", "10", "12", "12", "12"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Dm9": [{
        "positions": ["10", "12", "10", "10", "10", "12"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "5", "3", "5", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "5", "3", "5", "5", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "12", "10", "13", "12"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["10", "x", "10", "10", "10", "12"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Dm11": [{
        "positions": ["x", "5", "3", "5", "3", "3"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "5", "5", "5", "6", "5"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["10", "x", "10", "10", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "12", "12", "13", "13"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "5", "x", "5", "6", "3"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Dm13": [{
        "positions": ["x", "5", "x", "5", "6", "7"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["10", "12", "10", "10", "12", "10"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["10", "x", "10", "10", "12", "12"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "5", "7", "5", "6", "7"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "5", "3", "5", "5", "7"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "DmMaj9": [{
        "positions": ["x", "5", "3", "6", "5", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["10", "12", "11", "10", "10", "12"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "DMaj9": [{
        "positions": ["x", "5", "4", "6", "5", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "12", "11", "14", "12"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "5", "2", "2", "2", "2"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["10", "9", "11", "9", "10", "9"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["10", "x", "11", "9", "10", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "DMaj13": [{
        "positions": ["x", "5", "x", "6", "7", "7"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["10", "9", "9", "9", "10", "9"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["10", "x", "11", "11", "12", "12"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "D+9": [{
        "positions": ["x", "5", "4", "5", "5", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["10", "x", "10", "11", "11", "12"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "DMaj7#11": [{
        "positions": ["x", "5", "6", "6", "7", "5"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["10", "x", "11", "11", "9", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "12", "13", "14", "14"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "D9b5": [{
        "positions": ["x", "5", "4", "5", "5", "4"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["10", "9", "10", "9", "9", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "D7b9": [{
        "positions": ["x", "5", "4", "5", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["10", "12", "10", "11", "10", "11"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "5", "4", "5", "4", "5"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "12", "11", "13", "11"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "D7#9": [{
        "positions": ["x", "5", "4", "5", "6", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["10", "12", "10", "11", "10", "13"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "12", "11", "13", "13"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "D7b5#9": [{"positions": ["x", "5", "4", "5", "6", "4"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "D7#11": [{"positions": ["10", "11", "10", "11", "10", "10"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "D7b5": [{
        "positions": ["x", "5", "6", "5", "7", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["10", "x", "10", "11", "9", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "12", "13", "13", "14"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "5", "6", "5", "7", "8"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Dm9b5": [{"positions": ["10", "11", "10", "10", "13", "12"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "D+7b9": [{
        "positions": ["x", "5", "4", "5", "4", "6"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["10", "x", "10", "11", "11", "11"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "D+7#9": [{
        "positions": ["x", "5", "4", "5", "6", "6"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["10", "x", "10", "11", "11", "13"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "E": [{
        "positions": ["0", "2", "2", "1", "0", "0"],
        "fingerings": [["0", "2", "3", "1", "0", "0"]]
    }, {
        "positions": ["x", "7", "9", "9", "9", "7"],
        "fingerings": [["0", "1", "2", "3", "4", "1"], ["0", "1", "3", "3", "3", "1"]]
    }, {
        "positions": ["x", "7", "6", "4", "5", "4"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {
        "positions": ["0", "x", "2", "4", "5", "4"],
        "fingerings": [["0", "0", "1", "2", "4", "3"]]
    }, {
        "positions": ["12", "14", "14", "13", "12", "12"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["12", "11", "9", "9", "9", "12"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "2", "4", "5", "4"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Em": [{
        "positions": ["0", "2", "2", "0", "0", "0"],
        "fingerings": [["0", "2", "3", "0", "0", "0"], ["0", "1", "2", "0", "0", "0"], ["0", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "7", "9", "9", "8", "7"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["0", "10", "9", "0", "8", "0"],
        "fingerings": [["0", "3", "2", "0", "1", "0"], ["0", "4", "3", "0", "2", "0"]]
    }, {
        "positions": ["0", "x", "2", "4", "5", "3"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["12", "14", "14", "12", "12", "12"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "14", "12", "12", "12"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "2", "4", "5", "3"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "E5": [{
        "positions": ["0", "2", "2", "x", "x", "x"],
        "fingerings": [["0", "1", "2", "0", "0", "0"], ["0", "2", "3", "0", "0", "0"], ["0", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "7", "9", "9", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["12", "14", "14", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "9", "12", "12"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "2", "4", "5", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Esus2": [{
        "positions": ["0", "2", "2", "4", "5", "2"],
        "fingerings": [["0", "1", "1", "3", "4", "1"], ["0", "1", "1", "2", "3", "1"]]
    }, {
        "positions": ["0", "7", "4", "4", "7", "0"],
        "fingerings": [["0", "3", "1", "2", "4", "0"]]
    }, {
        "positions": ["0", "7", "9", "9", "7", "7"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "9", "9", "7", "7"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "9", "11", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "14", "11", "12", "14"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "2", "4", "5", "2"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Esus4": [{
        "positions": ["0", "2", "2", "2", "0", "0"],
        "fingerings": [["0", "2", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"]]
    }, {
        "positions": ["x", "7", "9", "9", "10", "7"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["0", "0", "2", "2", "0", "0"],
        "fingerings": [["0", "0", "1", "2", "0", "0"], ["0", "0", "2", "3", "0", "0"], ["0", "0", "3", "4", "0", "0"]]
    }, {
        "positions": ["0", "0", "2", "4", "0", "0"],
        "fingerings": [["0", "0", "1", "2", "0", "0"], ["0", "0", "1", "3", "0", "0"], ["0", "0", "2", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "2", "4", "5", "5"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "3", "4", "4"]]
    }, {
        "positions": ["12", "14", "14", "14", "12", "12"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {"positions": ["x", "x", "14", "14", "12", "12"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "E+": [{
        "positions": ["x", "7", "6", "5", "5", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "14", "13", "13", "12"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["12", "11", "10", "9", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["12", "15", "14", "13", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "7", "x", "9", "9", "8"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "E°": [{
        "positions": ["x", "7", "8", "9", "8", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["12", "x", "14", "12", "11", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["12", "13", "14", "12", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "E7": [{
        "positions": ["0", "2", "0", "1", "0", "0"],
        "fingerings": [["0", "2", "0", "1", "0", "0"], ["0", "3", "0", "1", "0", "0"]]
    }, {
        "positions": ["0", "2", "2", "1", "3", "0"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "7", "9", "7", "9", "7"],
        "fingerings": [["0", "1", "3", "1", "4", "1"], ["0", "1", "2", "1", "3", "1"]]
    }, {
        "positions": ["0", "2", "0", "1", "3", "0"],
        "fingerings": [["0", "2", "0", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "4", "3", "4"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "7", "6", "7", "5", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "12"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {"positions": ["12", "x", "12", "13", "12", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "E7sus4": [{
        "positions": ["0", "2", "0", "2", "0", "0"],
        "fingerings": [["0", "1", "0", "2", "0", "0"], ["0", "1", "0", "3", "0", "0"], ["0", "2", "0", "3", "0", "0"]]
    }, {
        "positions": ["x", "7", "9", "7", "10", "7"],
        "fingerings": [["0", "1", "3", "1", "4", "1"], ["0", "1", "2", "1", "3", "1"]]
    }, {
        "positions": ["x", "7", "7", "7", "5", "5"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["12", "14", "12", "14", "12", "12"],
        "fingerings": [["1", "3", "1", "4", "1", "1"], ["1", "2", "1", "3", "1", "1"]]
    }, {"positions": ["x", "x", "2", "4", "3", "5"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Em7": [{
        "positions": ["0", "2", "2", "0", "3", "0"],
        "fingerings": [["0", "1", "2", "0", "3", "0"], ["0", "2", "3", "0", "4", "0"], ["0", "1", "2", "0", "4", "0"]]
    }, {
        "positions": ["x", "7", "9", "7", "8", "7"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["0", "2", "2", "0", "3", "3"],
        "fingerings": [["0", "1", "2", "0", "3", "4"]]
    }, {
        "positions": ["12", "x", "12", "12", "12", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "7", "5", "7", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["12", "14", "14", "12", "15", "12"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["12", "14", "12", "12", "12", "12"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "7", "5", "7", "5", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "2", "4", "3", "3"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "EMaj7": [{
        "positions": ["0", "2", "1", "1", "0", "x"],
        "fingerings": [["0", "3", "1", "2", "0", "0"]]
    }, {
        "positions": ["x", "x", "2", "4", "4", "4"],
        "fingerings": [["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "7", "9", "8", "9", "7"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "7", "6", "4", "4", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "14", "13", "12", "11"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["12", "x", "13", "13", "12", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["12", "14", "13", "13", "12", "12"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Em7b5": [{
        "positions": ["x", "7", "8", "7", "8", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"], ["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "3", "3"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "3", "3", "3"], ["0", "0", "2", "3", "3", "3"]]
    }, {
        "positions": ["0", "1", "2", "3", "3", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["12", "x", "12", "12", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["12", "13", "14", "15", "15", "15"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "7", "x", "7", "8", "6"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["12", "13", "12", "12", "15", "12"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "E°7": [{
        "positions": ["0", "1", "2", "0", "2", "0"],
        "fingerings": [["0", "1", "2", "0", "3", "0"], ["0", "1", "2", "0", "4", "0"], ["0", "2", "3", "0", "4", "0"]]
    }, {
        "positions": ["0", "7", "8", "6", "8", "0"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "2", "3"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "7", "8", "6", "8", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {"positions": ["12", "x", "11", "12", "11", "x"], "fingerings": [["3", "0", "1", "4", "2", "0"]]}],
    "E+7": [{
        "positions": ["x", "7", "10", "7", "9", "8"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["12", "x", "12", "13", "13", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "5", "3", "4"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "7", "x", "7", "9", "8"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "EmMaj7": [{
        "positions": ["x", "7", "9", "8", "8", "7"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["12", "x", "13", "12", "12", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["12", "14", "13", "12", "12", "12"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "2", "4", "4", "3"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "14", "12", "12", "11"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Eadd9": [{
        "positions": ["0", "2", "4", "1", "0", "0"],
        "fingerings": [["0", "2", "4", "1", "0", "0"]]
    }, {
        "positions": ["0", "2", "2", "1", "0", "2"],
        "fingerings": [["0", "2", "3", "1", "0", "4"]]
    }, {
        "positions": ["x", "7", "9", "9", "7", "7"],
        "fingerings": [["0", "1", "3", "4", "1", "1"], ["0", "1", "2", "3", "1", "1"]]
    }, {
        "positions": ["x", "x", "14", "13", "12", "14"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "7", "9", "11", "9", "7"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["12", "x", "x", "13", "12", "14"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Emadd9": [{"positions": ["x", "x", "14", "12", "12", "14"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "E6": [{
        "positions": ["0", "2", "2", "1", "2", "0"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "7", "9", "9", "9", "9"],
        "fingerings": [["0", "1", "2", "3", "4", "4"], ["0", "1", "4", "4", "4", "4"]]
    }, {
        "positions": ["x", "x", "2", "4", "2", "4"],
        "fingerings": [["0", "0", "1", "3", "1", "4"]]
    }, {
        "positions": ["x", "x", "2", "1", "2", "0"],
        "fingerings": [["0", "0", "2", "1", "3", "0"], ["0", "0", "3", "2", "4", "0"]]
    }, {"positions": ["12", "x", "11", "13", "12", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Em6": [{
        "positions": ["0", "2", "2", "0", "2", "0"],
        "fingerings": [["0", "1", "2", "0", "3", "0"], ["0", "2", "3", "0", "4", "0"], ["0", "1", "2", "0", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "4", "2", "3"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "7", "5", "6", "5", "x"],
        "fingerings": [["0", "3", "1", "2", "1", "0"], ["0", "4", "1", "2", "1", "0"]]
    }, {
        "positions": ["x", "7", "9", "6", "8", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["12", "14", "14", "12", "14", "12"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "7", "5", "6", "5", "7"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["12", "x", "11", "12", "12", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "7", "x", "6", "8", "7"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Emb6": [{
        "positions": ["x", "7", "5", "5", "5", "7"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["12", "x", "10", "12", "12", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "E9": [{
        "positions": ["0", "2", "0", "1", "0", "2"],
        "fingerings": [["0", "2", "0", "1", "0", "3"], ["0", "2", "0", "1", "0", "4"]]
    }, {
        "positions": ["0", "7", "6", "7", "7", "0"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["12", "x", "12", "11", "12", "12"],
        "fingerings": [["2", "0", "3", "1", "4", "4"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "14"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "7", "6", "7", "7", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["12", "x", "12", "11", "9", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "1", "3", "2"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["12", "11", "12", "11", "12", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "E11": [{
        "positions": ["0", "2", "0", "2", "0", "2"],
        "fingerings": [["0", "1", "0", "2", "0", "3"], ["0", "2", "0", "3", "0", "4"]]
    }, {
        "positions": ["0", "7", "7", "7", "7", "7"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["12", "x", "12", "11", "10", "10"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "7", "6", "7", "5", "5"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "7", "7", "9", "7"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "2", "2", "3", "4"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "E13": [{
        "positions": ["0", "x", "0", "1", "2", "2"],
        "fingerings": [["0", "0", "0", "1", "2", "3"], ["0", "0", "0", "2", "3", "4"]]
    }, {
        "positions": ["x", "7", "6", "7", "7", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["12", "x", "12", "11", "9", "9"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["12", "x", "12", "13", "14", "14"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["12", "14", "12", "13", "14", "12"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "E9sus4": [{
        "positions": ["x", "7", "7", "7", "7", "7"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["12", "x", "12", "11", "10", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["12", "x", "12", "11", "10", "10"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "E13sus4": [{
        "positions": ["x", "7", "7", "7", "7", "9"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["12", "x", "12", "14", "14", "14"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Em9": [{
        "positions": ["x", "7", "5", "7", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["0", "2", "2", "0", "3", "2"],
        "fingerings": [["0", "1", "2", "0", "4", "3"]]
    }, {
        "positions": ["12", "14", "12", "12", "12", "14"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "7", "5", "7", "7", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "14", "12", "15", "14"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["12", "x", "12", "12", "12", "14"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Em11": [{
        "positions": ["x", "7", "5", "7", "5", "5"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "7", "7", "8", "7"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["12", "x", "12", "12", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "2", "3", "3"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "7", "x", "7", "8", "5"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Em13": [{
        "positions": ["x", "7", "x", "7", "8", "9"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["12", "14", "12", "12", "14", "12"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["12", "x", "12", "12", "14", "14"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "7", "9", "7", "8", "9"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "7", "5", "7", "7", "9"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "EmMaj9": [{
        "positions": ["x", "7", "5", "8", "7", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["12", "14", "13", "12", "12", "14"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "EMaj9": [{
        "positions": ["x", "7", "6", "8", "7", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "2", "1", "4", "2"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "7", "4", "4", "4", "4"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["12", "11", "13", "11", "12", "11"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["12", "x", "13", "11", "12", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "EMaj13": [{
        "positions": ["x", "7", "x", "8", "9", "9"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["12", "11", "11", "11", "12", "11"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["12", "x", "13", "13", "14", "14"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "E+9": [{
        "positions": ["x", "7", "6", "7", "7", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["12", "x", "12", "13", "13", "14"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "EMaj7#11": [{
        "positions": ["x", "7", "8", "8", "9", "7"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["12", "x", "13", "13", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "4", "4"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "E9b5": [{
        "positions": ["x", "7", "6", "7", "7", "6"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["12", "11", "12", "11", "11", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "E7b9": [{
        "positions": ["x", "7", "6", "7", "6", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "13"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "7", "6", "7", "6", "7"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "2", "1", "3", "1"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "E7#9": [{
        "positions": ["x", "7", "6", "7", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "15"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "2", "1", "3", "3"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "E7b5#9": [{"positions": ["x", "7", "6", "7", "8", "6"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "E7#11": [{"positions": ["12", "13", "12", "13", "12", "12"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "E7b5": [{
        "positions": ["x", "7", "8", "7", "9", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["12", "x", "12", "13", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "3", "4"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "7", "8", "7", "9", "10"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Em9b5": [{"positions": ["12", "13", "12", "12", "15", "14"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "E+7b9": [{
        "positions": ["x", "7", "6", "7", "6", "8"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["12", "x", "12", "13", "13", "13"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "E+7#9": [{
        "positions": ["x", "7", "6", "7", "8", "8"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["12", "x", "12", "13", "13", "15"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "F": [{
        "positions": ["1", "3", "3", "2", "1", "1"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "10", "10", "8"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "8", "7", "5", "6", "5"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {
        "positions": ["x", "x", "3", "2", "1", "1"],
        "fingerings": [["0", "0", "3", "2", "1", "1"]]
    }, {
        "positions": ["13", "12", "10", "10", "10", "13"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "3", "5", "6", "5"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Fm": [{
        "positions": ["1", "3", "3", "1", "1", "1"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "10", "9", "8"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "6", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "3", "1", "1", "1"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "F5": [{
        "positions": ["1", "3", "3", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "8", "10", "10", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "10", "13", "13"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "3", "5", "6", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Fsus2": [{
        "positions": ["x", "8", "10", "10", "8", "8"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "6", "3"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "8", "10", "12", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {"positions": ["x", "x", "15", "12", "13", "15"], "fingerings": [["0", "0", "3", "1", "2", "4"]]}],
    "Fsus4": [{
        "positions": ["1", "3", "3", "3", "1", "1"],
        "fingerings": [["1", "3", "3", "3", "1", "1"], ["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "10", "11", "8"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "8", "8", "5", "6", "x"],
        "fingerings": [["0", "3", "4", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "3", "5", "6", "6"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "x", "3", "3", "1", "1"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "F+": [{
        "positions": ["x", "8", "7", "6", "6", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "3", "2", "2", "1"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["13", "12", "11", "10", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["1", "4", "3", "2", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "8", "x", "10", "10", "9"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "F°": [{
        "positions": ["x", "8", "9", "10", "9", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["13", "x", "15", "13", "12", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["1", "2", "3", "1", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "F7": [{
        "positions": ["1", "3", "1", "2", "1", "1"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "8", "10", "8"],
        "fingerings": [["0", "1", "3", "1", "4", "1"], ["0", "1", "2", "1", "3", "1"]]
    }, {
        "positions": ["1", "x", "1", "2", "1", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "3", "5", "4", "5"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "8", "7", "8", "6", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "F7sus4": [{
        "positions": ["1", "3", "1", "3", "1", "1"],
        "fingerings": [["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "8", "11", "8"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["13", "15", "13", "15", "13", "13"],
        "fingerings": [["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "8", "8", "6", "6"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {"positions": ["x", "x", "3", "5", "4", "6"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Fm7": [{
        "positions": ["1", "3", "1", "1", "1", "1"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "8", "9", "8"],
        "fingerings": [["0", "1", "3", "1", "2", "1"]]
    }, {
        "positions": ["1", "x", "1", "1", "1", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "8", "6", "8", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["1", "3", "3", "1", "4", "1"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "8", "6", "8", "6", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "3", "5", "4", "4"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "FMaj7": [{
        "positions": ["x", "x", "3", "2", "1", "0"],
        "fingerings": [["0", "0", "3", "2", "1", "0"]]
    }, {
        "positions": ["x", "8", "10", "9", "10", "8"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "5", "5"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "4", "4", "4"]]
    }, {
        "positions": ["1", "x", "2", "2", "1", "0"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "8", "7", "5", "5", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "15", "14", "13", "12"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["1", "x", "2", "2", "1", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["1", "3", "2", "2", "1", "1"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Fm7b5": [{
        "positions": ["x", "8", "9", "8", "9", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "4", "4"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "3", "3", "3"], ["0", "0", "2", "3", "3", "3"]]
    }, {
        "positions": ["1", "x", "1", "1", "0", "x"],
        "fingerings": [["1", "0", "2", "3", "0", "0"], ["2", "0", "3", "4", "0", "0"], ["1", "0", "3", "4", "0", "0"]]
    }, {
        "positions": ["1", "2", "3", "4", "4", "4"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["13", "x", "13", "13", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "8", "x", "8", "9", "7"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["1", "2", "1", "1", "4", "1"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "F°7": [{
        "positions": ["1", "2", "0", "1", "x", "x"],
        "fingerings": [["1", "3", "0", "2", "0", "0"], ["2", "4", "0", "3", "0", "0"]]
    }, {
        "positions": ["x", "8", "9", "7", "9", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "3", "4"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["1", "x", "0", "1", "0", "x"],
        "fingerings": [["1", "0", "0", "3", "0", "0"], ["2", "0", "0", "3", "0", "0"]]
    }, {
        "positions": ["1", "2", "3", "1", "3", "1"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {"positions": ["13", "x", "12", "13", "12", "x"], "fingerings": [["3", "0", "1", "4", "2", "0"]]}],
    "F+7": [{
        "positions": ["x", "8", "11", "8", "10", "9"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["1", "x", "1", "2", "2", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "3", "6", "4", "5"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "8", "x", "8", "10", "9"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "FmMaj7": [{
        "positions": ["x", "8", "10", "9", "9", "8"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["1", "x", "2", "1", "1", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["1", "3", "2", "1", "1", "1"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "5", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "15", "13", "13", "12"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Fadd9": [{
        "positions": ["x", "x", "3", "2", "1", "3"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "8", "10", "10", "8", "8"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "12", "10", "8"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["1", "x", "x", "2", "1", "3"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Fmadd9": [{"positions": ["x", "x", "3", "1", "1", "3"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "F6": [{
        "positions": ["x", "x", "3", "2", "3", "1"],
        "fingerings": [["0", "0", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "8", "10", "10", "10", "10"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "3", "5", "3", "5"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["13", "x", "12", "14", "13", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Fm6": [{
        "positions": ["1", "3", "3", "1", "3", "1"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "3", "4"],
        "fingerings": [["0", "0", "1", "3", "1", "2"]]
    }, {
        "positions": ["x", "8", "6", "7", "6", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["1", "x", "0", "1", "1", "x"],
        "fingerings": [["1", "0", "0", "2", "3", "0"], ["1", "0", "0", "3", "4", "0"], ["2", "0", "0", "3", "4", "0"]]
    }, {
        "positions": ["x", "8", "10", "7", "9", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "8", "6", "7", "6", "8"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["13", "x", "12", "13", "13", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "8", "x", "7", "9", "8"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Fmb6": [{
        "positions": ["x", "8", "6", "6", "6", "8"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["13", "x", "11", "13", "13", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "F9": [{
        "positions": ["1", "3", "1", "2", "1", "3"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["1", "x", "1", "0", "1", "1"],
        "fingerings": [["1", "0", "2", "0", "3", "4"]]
    }, {
        "positions": ["x", "8", "7", "8", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "8", "7", "8", "8", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["13", "x", "13", "12", "10", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "2", "4", "3"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["13", "12", "13", "12", "13", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "F11": [{
        "positions": ["1", "3", "1", "3", "1", "3"],
        "fingerings": [["1", "2", "1", "3", "1", "4"]]
    }, {
        "positions": ["x", "8", "8", "8", "8", "8"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "8", "7", "8", "6", "6"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "8", "8", "10", "8"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "3", "3", "4", "5"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "F13": [{
        "positions": ["1", "0", "1", "2", "3", "3"],
        "fingerings": [["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "8", "7", "8", "8", "10"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["13", "x", "13", "12", "10", "10"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["1", "x", "1", "2", "3", "3"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["1", "3", "1", "2", "3", "1"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "F9sus4": [{
        "positions": ["x", "8", "8", "8", "8", "8"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["13", "x", "13", "12", "11", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["13", "x", "13", "12", "11", "11"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "F13sus4": [{
        "positions": ["x", "8", "8", "8", "8", "10"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["1", "x", "1", "3", "3", "3"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Fm9": [{
        "positions": ["1", "3", "1", "1", "1", "3"],
        "fingerings": [["1", "2", "1", "1", "1", "4"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "8", "6", "8", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "8", "6", "8", "8", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "3", "1", "4", "3"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["1", "x", "1", "1", "1", "3"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Fm11": [{
        "positions": ["x", "8", "6", "8", "6", "6"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "8", "8", "9", "8"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["13", "x", "13", "13", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "3", "4", "4"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "8", "x", "8", "9", "6"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Fm13": [{
        "positions": ["x", "8", "x", "8", "9", "10"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["1", "3", "1", "1", "3", "1"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["1", "x", "1", "1", "3", "3"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "8", "10", "8", "9", "10"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "8", "6", "8", "8", "10"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "FmMaj9": [{
        "positions": ["x", "8", "6", "9", "8", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["1", "3", "2", "1", "1", "3"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "FMaj9": [{
        "positions": ["x", "8", "7", "9", "8", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "3", "2", "5", "3"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "8", "5", "5", "5", "5"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["13", "12", "14", "12", "13", "12"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["13", "x", "14", "12", "13", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "FMaj13": [{
        "positions": ["x", "8", "x", "9", "10", "10"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["13", "12", "12", "12", "13", "12"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["1", "x", "2", "2", "3", "3"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "F+9": [{
        "positions": ["x", "8", "7", "8", "8", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["1", "x", "1", "2", "2", "3"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "FMaj7#11": [{
        "positions": ["x", "8", "9", "9", "10", "8"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["13", "x", "14", "14", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "5", "5"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "F9b5": [{
        "positions": ["x", "8", "7", "8", "8", "7"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["13", "12", "13", "12", "12", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "F7b9": [{
        "positions": ["x", "8", "7", "8", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["1", "3", "1", "2", "1", "2"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "8", "7", "8", "7", "8"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "3", "2", "4", "2"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "F7#9": [{
        "positions": ["x", "8", "7", "8", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["1", "3", "1", "2", "1", "4"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "3", "2", "4", "4"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "F7b5#9": [{"positions": ["x", "8", "7", "8", "9", "7"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "F7#11": [{"positions": ["1", "2", "1", "2", "1", "1"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "F7b5": [{
        "positions": ["x", "8", "9", "8", "10", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["13", "x", "13", "14", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "4", "5"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "8", "9", "8", "10", "11"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Fm9b5": [{"positions": ["1", "2", "1", "1", "4", "3"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "F+7b9": [{
        "positions": ["x", "8", "7", "8", "7", "9"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["1", "x", "1", "2", "2", "2"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "F+7#9": [{
        "positions": ["x", "8", "7", "8", "9", "9"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["1", "x", "1", "2", "2", "4"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "G": [{
        "positions": ["3", "2", "0", "0", "3", "3"],
        "fingerings": [["2", "1", "0", "0", "3", "4"]]
    }, {
        "positions": ["3", "5", "5", "4", "3", "3"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["3", "2", "0", "x", "x", "x"],
        "fingerings": [["2", "1", "0", "0", "0", "0"], ["3", "2", "0", "0", "0", "0"], ["4", "3", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "10", "12", "12", "12", "10"],
        "fingerings": [["0", "1", "2", "3", "4", "1"], ["0", "1", "3", "3", "3", "1"]]
    }, {
        "positions": ["x", "10", "9", "7", "8", "7"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {
        "positions": ["15", "14", "12", "12", "12", "15"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "5", "7", "8", "7"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Gm": [{
        "positions": ["3", "5", "5", "3", "3", "3"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "10", "12", "12", "11", "10"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["x", "x", "5", "7", "8", "6"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "5", "3", "3", "3"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "G5": [{
        "positions": ["3", "5", "5", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"], ["1", "2", "3", "0", "0", "0"], ["1", "3", "3", "0", "0", "0"]]
    }, {
        "positions": ["x", "10", "12", "12", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "12", "15", "15"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "5", "7", "8", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Gsus2": [{
        "positions": ["3", "0", "0", "0", "3", "3"],
        "fingerings": [["2", "0", "0", "0", "3", "4"], ["1", "0", "0", "0", "2", "3"]]
    }, {
        "positions": ["3", "5", "5", "2", "x", "x"],
        "fingerings": [["2", "3", "4", "1", "0", "0"]]
    }, {
        "positions": ["3", "x", "0", "2", "3", "3"],
        "fingerings": [["2", "0", "0", "1", "3", "4"]]
    }, {
        "positions": ["x", "10", "12", "12", "10", "10"],
        "fingerings": [["0", "1", "3", "4", "1", "1"], ["0", "1", "2", "3", "1", "1"]]
    }, {
        "positions": ["x", "x", "5", "7", "8", "5"],
        "fingerings": [["0", "0", "1", "3", "4", "1"], ["0", "0", "1", "2", "3", "1"]]
    }, {
        "positions": ["x", "10", "12", "14", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {"positions": ["x", "x", "5", "2", "3", "5"], "fingerings": [["0", "0", "3", "1", "2", "4"]]}],
    "Gsus4": [{
        "positions": ["3", "3", "0", "0", "1", "3"],
        "fingerings": [["2", "3", "0", "0", "1", "4"]]
    }, {
        "positions": ["3", "5", "5", "5", "3", "3"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "10", "10", "7", "8", "x"],
        "fingerings": [["0", "3", "4", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "5", "7", "8", "8"],
        "fingerings": [["0", "0", "1", "2", "3", "4"], ["0", "0", "1", "2", "4", "4"]]
    }, {
        "positions": ["x", "10", "12", "12", "13", "10"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {"positions": ["x", "x", "5", "5", "3", "3"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "G+": [{
        "positions": ["x", "10", "9", "8", "8", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "5", "4", "4", "3"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["15", "14", "13", "12", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["3", "6", "5", "4", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "10", "x", "12", "12", "11"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "G°": [{
        "positions": ["x", "10", "11", "12", "11", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["3", "x", "5", "3", "2", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["3", "4", "5", "3", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "G7": [{
        "positions": ["3", "2", "0", "0", "0", "1"],
        "fingerings": [["3", "2", "0", "0", "0", "1"]]
    }, {
        "positions": ["3", "5", "3", "4", "3", "3"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "10", "12", "10", "12", "10"],
        "fingerings": [["0", "1", "2", "1", "3", "1"], ["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "5", "7", "6", "7"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "10", "9", "10", "8", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["3", "x", "3", "4", "3", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "G7sus4": [{
        "positions": ["3", "5", "3", "5", "3", "3"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "10", "10", "10", "8", "8"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "10", "12", "10", "13", "10"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "5", "7", "6", "8"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Gm7": [{
        "positions": ["3", "5", "3", "3", "3", "3"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["3", "x", "3", "3", "3", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "10", "12", "10", "11", "10"],
        "fingerings": [["0", "1", "3", "1", "2", "1"]]
    }, {
        "positions": ["x", "10", "8", "10", "11", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["3", "5", "5", "3", "6", "3"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "10", "8", "10", "8", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "5", "7", "6", "6"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "GMaj7": [{
        "positions": ["3", "2", "0", "0", "0", "2"],
        "fingerings": [["3", "2", "0", "0", "0", "1"], ["2", "1", "0", "0", "0", "3"]]
    }, {
        "positions": ["x", "x", "5", "4", "3", "2"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "5", "7", "7", "7"],
        "fingerings": [["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "10", "12", "11", "12", "10"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["3", "x", "4", "4", "3", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "10", "9", "7", "7", "x"],
        "fingerings": [["0", "4", "3", "1", "1", "0"], ["0", "3", "2", "1", "1", "0"]]
    }, {"positions": ["3", "5", "4", "4", "3", "3"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Gm7b5": [{
        "positions": ["3", "x", "3", "3", "2", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "5", "6", "6", "6"],
        "fingerings": [["0", "0", "1", "2", "2", "2"], ["0", "0", "1", "3", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "10", "11", "10", "11", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["3", "4", "5", "6", "6", "6"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "10", "x", "10", "11", "9"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["3", "4", "3", "3", "6", "3"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "G°7": [{
        "positions": ["3", "4", "2", "3", "x", "x"],
        "fingerings": [["2", "4", "1", "3", "0", "0"]]
    }, {
        "positions": ["x", "10", "11", "9", "11", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "5", "6", "5", "6"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["3", "4", "5", "3", "5", "3"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {"positions": ["3", "x", "2", "3", "2", "x"], "fingerings": [["3", "0", "1", "4", "2", "0"]]}],
    "G+7": [{
        "positions": ["x", "10", "13", "10", "12", "11"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["3", "x", "3", "4", "4", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "5", "8", "6", "7"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "10", "x", "10", "12", "11"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "GmMaj7": [{
        "positions": ["x", "10", "12", "11", "11", "10"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["3", "x", "4", "3", "3", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["3", "5", "4", "3", "3", "3"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "5", "7", "7", "6"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "5", "3", "3", "2"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Gadd9": [{
        "positions": ["3", "2", "0", "0", "0", "5"],
        "fingerings": [["2", "1", "0", "0", "0", "4"]]
    }, {
        "positions": ["3", "2", "0", "2", "0", "3"],
        "fingerings": [["3", "1", "0", "2", "0", "4"]]
    }, {
        "positions": ["x", "x", "5", "4", "3", "5"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "10", "12", "12", "10", "10"],
        "fingerings": [["0", "1", "3", "4", "1", "1"], ["0", "1", "2", "3", "1", "1"]]
    }, {
        "positions": ["x", "10", "12", "14", "12", "10"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["3", "x", "x", "4", "3", "5"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Gmadd9": [{"positions": ["x", "x", "5", "3", "3", "5"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "G6": [{
        "positions": ["3", "2", "0", "0", "0", "0"],
        "fingerings": [["3", "2", "0", "0", "0", "0"], ["2", "1", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "5", "4", "5", "3"],
        "fingerings": [["0", "0", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "10", "12", "12", "12", "12"],
        "fingerings": [["0", "1", "3", "3", "3", "3"], ["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "5", "7", "5", "7"],
        "fingerings": [["0", "0", "1", "2", "1", "3"], ["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["3", "x", "2", "4", "3", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Gm6": [{
        "positions": ["3", "5", "5", "3", "5", "3"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "5", "7", "5", "6"],
        "fingerings": [["0", "0", "1", "3", "1", "2"]]
    }, {
        "positions": ["x", "10", "8", "9", "8", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["3", "x", "2", "3", "3", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "10", "12", "9", "11", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "10", "8", "9", "8", "10"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "10", "x", "9", "11", "10"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Gmb6": [{
        "positions": ["x", "10", "8", "8", "8", "10"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["3", "x", "1", "3", "3", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "G9": [{
        "positions": ["3", "5", "3", "4", "3", "5"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "10", "9", "10", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "10", "9", "10", "10", "10"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["15", "x", "15", "14", "12", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "5", "4", "6", "5"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["3", "2", "3", "2", "3", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "G11": [{
        "positions": ["3", "x", "3", "2", "1", "1"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["3", "5", "3", "5", "3", "5"],
        "fingerings": [["1", "2", "1", "3", "1", "4"]]
    }, {
        "positions": ["x", "10", "10", "10", "10", "10"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "10", "9", "10", "8", "8"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "10", "10", "10", "12", "10"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "5", "5", "6", "7"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "G13": [{
        "positions": ["3", "x", "3", "2", "0", "0"],
        "fingerings": [["2", "0", "3", "1", "0", "0"], ["3", "0", "4", "2", "0", "0"]]
    }, {
        "positions": ["3", "x", "3", "4", "5", "5"],
        "fingerings": [["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "10", "9", "10", "10", "12"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["15", "x", "15", "14", "12", "12"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {"positions": ["3", "5", "3", "4", "5", "3"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "G9sus4": [{
        "positions": ["x", "10", "10", "10", "10", "10"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["3", "x", "3", "2", "1", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["3", "x", "3", "2", "1", "1"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "G13sus4": [{
        "positions": ["x", "10", "10", "10", "10", "12"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["3", "x", "3", "5", "5", "5"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Gm9": [{
        "positions": ["3", "5", "3", "3", "3", "5"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "10", "8", "10", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "10", "8", "10", "10", "10"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "5", "3", "6", "5"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["3", "x", "3", "3", "3", "5"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Gm11": [{
        "positions": ["x", "10", "8", "10", "8", "8"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "10", "10", "10", "11", "10"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["3", "x", "3", "3", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "5", "5", "6", "6"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "10", "x", "10", "11", "8"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Gm13": [{
        "positions": ["x", "10", "x", "10", "11", "12"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["3", "5", "3", "3", "5", "3"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["3", "x", "3", "3", "5", "5"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "10", "12", "10", "11", "12"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "10", "8", "10", "10", "12"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "GmMaj9": [{
        "positions": ["x", "10", "8", "11", "10", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["3", "5", "4", "3", "3", "5"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "GMaj9": [{
        "positions": ["x", "10", "9", "11", "10", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "5", "4", "7", "5"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "10", "7", "7", "7", "7"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["3", "2", "4", "2", "3", "2"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["3", "x", "4", "2", "3", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "GMaj13": [{
        "positions": ["x", "10", "x", "11", "12", "12"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["3", "2", "2", "2", "3", "2"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["3", "x", "4", "4", "5", "5"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "G+9": [{
        "positions": ["x", "10", "9", "10", "10", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["3", "x", "3", "4", "4", "5"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "GMaj7#11": [{
        "positions": ["x", "10", "11", "11", "12", "10"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["3", "x", "4", "4", "2", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "5", "6", "7", "7"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "G9b5": [{
        "positions": ["x", "10", "9", "10", "10", "9"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["3", "2", "3", "2", "2", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "G7b9": [{
        "positions": ["x", "10", "9", "10", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["3", "5", "3", "4", "3", "4"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "10", "9", "10", "9", "10"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "5", "4", "6", "4"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "G7#9": [{
        "positions": ["x", "10", "9", "10", "11", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["3", "5", "3", "4", "3", "6"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "5", "4", "6", "6"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "G7b5#9": [{"positions": ["x", "10", "9", "10", "11", "9"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "G7#11": [{"positions": ["3", "4", "3", "4", "3", "3"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "G7b5": [{
        "positions": ["x", "10", "11", "10", "12", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["3", "x", "3", "4", "2", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "5", "6", "6", "7"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "10", "11", "10", "12", "13"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Gm9b5": [{"positions": ["3", "4", "3", "3", "6", "5"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "G+7b9": [{
        "positions": ["x", "10", "9", "10", "9", "11"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["3", "x", "3", "4", "4", "4"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "G+7#9": [{
        "positions": ["x", "10", "9", "10", "11", "11"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["3", "x", "3", "4", "4", "6"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Ab": [{
        "positions": ["4", "6", "6", "5", "4", "4"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "11", "10", "8", "9", "8"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {
        "positions": ["x", "11", "13", "13", "13", "11"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["4", "3", "1", "1", "1", "4"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "6", "8", "9", "8"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Abm": [{
        "positions": ["4", "6", "6", "4", "4", "4"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "9", "7"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "11", "13", "13", "12", "11"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {"positions": ["x", "x", "6", "4", "4", "4"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "Ab5": [{
        "positions": ["4", "6", "6", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "13", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "1", "4", "4"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "6", "8", "9", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Absus2": [{
        "positions": ["4", "1", "1", "1", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "13", "11", "11"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "13", "15", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "6", "3", "4", "6"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "6", "8", "9", "6"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Absus4": [{
        "positions": ["4", "6", "6", "6", "4", "4"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "8", "9", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "13", "14", "11"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "9", "9"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "6", "6", "4", "4"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Ab+": [{
        "positions": ["x", "11", "10", "9", "9", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "6", "5", "5", "4"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["4", "3", "2", "1", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["4", "7", "6", "5", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "11", "x", "13", "13", "12"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Ab°": [{
        "positions": ["x", "11", "12", "13", "12", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["4", "x", "6", "4", "3", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["4", "5", "6", "4", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Ab7": [{
        "positions": ["4", "6", "4", "5", "4", "4"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "5", "4", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "11", "13", "11", "13", "11"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "7", "8"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "11", "10", "11", "9", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "Ab7sus4": [{
        "positions": ["4", "6", "4", "6", "4", "4"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "9", "9"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "13", "11", "14", "11"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "6", "8", "7", "9"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Abm7": [{
        "positions": ["4", "6", "4", "4", "4", "4"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "4", "4", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "11", "13", "11", "12", "11"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["4", "6", "6", "4", "7", "4"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "11", "9", "11", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "11", "9", "11", "9", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "6", "8", "7", "7"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "AbMaj7": [{
        "positions": ["x", "x", "6", "5", "4", "3"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "8", "8"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "11", "13", "12", "13", "11"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["4", "x", "5", "5", "4", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["4", "6", "5", "5", "4", "4"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Abm7b5": [{
        "positions": ["x", "x", "6", "7", "7", "7"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["4", "x", "4", "4", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["4", "5", "6", "7", "7", "7"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "11", "12", "11", "12", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "11", "x", "11", "12", "10"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["4", "5", "4", "4", "7", "4"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Ab°7": [{
        "positions": ["4", "5", "6", "4", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "12", "13", "12", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "12", "10", "12", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["4", "x", "3", "4", "3", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "6", "7", "6", "7"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "Ab+7": [{
        "positions": ["x", "11", "14", "11", "13", "12"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["4", "x", "4", "5", "5", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "6", "9", "7", "8"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "11", "x", "11", "13", "12"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "AbmMaj7": [{
        "positions": ["x", "11", "13", "12", "12", "11"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["4", "x", "5", "4", "4", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["4", "6", "5", "4", "4", "4"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "8", "7"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "6", "4", "4", "3"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Abadd9": [{
        "positions": ["x", "x", "6", "5", "4", "6"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "11", "8", "8", "9", "8"],
        "fingerings": [["0", "4", "1", "1", "2", "1"]]
    }, {
        "positions": ["x", "11", "13", "15", "13", "11"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {
        "positions": ["x", "x", "6", "5", "4", "6"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "11", "13", "15", "13", "11"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["4", "x", "x", "5", "4", "6"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Abmadd9": [{"positions": ["x", "x", "6", "4", "4", "6"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Ab6": [{
        "positions": ["x", "x", "6", "5", "6", "4"],
        "fingerings": [["0", "0", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "6", "8"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "11", "13", "13", "13", "13"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {"positions": ["4", "x", "3", "5", "4", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Abm6": [{
        "positions": ["4", "6", "6", "4", "6", "4"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "6", "7"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "11", "9", "10", "9", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "11", "13", "10", "12", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "11", "9", "10", "9", "11"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["4", "x", "3", "4", "4", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "11", "x", "10", "12", "11"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Abmb6": [{
        "positions": ["x", "11", "9", "9", "9", "11"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["4", "x", "2", "4", "4", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Ab9": [{
        "positions": ["4", "6", "4", "5", "4", "6"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["4", "x", "4", "3", "4", "4"],
        "fingerings": [["2", "0", "3", "1", "4", "4"]]
    }, {
        "positions": ["x", "11", "x", "10", "11", "11"],
        "fingerings": [["0", "2", "0", "1", "3", "4"]]
    }, {
        "positions": ["x", "11", "10", "11", "11", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["4", "x", "4", "3", "1", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "5", "7", "6"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["4", "3", "4", "3", "4", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Ab11": [{
        "positions": ["4", "6", "4", "6", "4", "6"],
        "fingerings": [["1", "2", "1", "3", "1", "4"]]
    }, {
        "positions": ["4", "x", "4", "3", "2", "2"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "11", "11"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "11", "10", "11", "9", "9"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "13", "11"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "6", "6", "7", "8"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Ab13": [{
        "positions": ["4", "x", "4", "3", "1", "1"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "5", "6", "6"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {
        "positions": ["x", "11", "10", "11", "11", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["4", "6", "4", "5", "6", "4"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Ab9sus4": [{
        "positions": ["x", "11", "11", "11", "11", "11"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "3", "2", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["4", "x", "4", "3", "2", "2"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Ab13sus4": [{
        "positions": ["x", "11", "11", "11", "11", "13"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["4", "x", "4", "6", "6", "6"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Abm9": [{
        "positions": ["4", "6", "4", "4", "4", "6"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "11", "9", "11", "11", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "11", "9", "11", "11", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "6", "4", "7", "6"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["4", "x", "4", "4", "4", "6"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Abm11": [{
        "positions": ["x", "11", "9", "11", "9", "9"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "12", "11"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["4", "x", "4", "4", "2", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "6", "7", "7"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "11", "x", "11", "12", "9"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Abm13": [{
        "positions": ["x", "11", "x", "11", "12", "13"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["4", "6", "4", "4", "6", "4"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["4", "x", "4", "4", "6", "6"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "11", "13", "11", "12", "13"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "11", "9", "11", "11", "13"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "AbmMaj9": [{
        "positions": ["x", "11", "9", "12", "11", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["4", "6", "5", "4", "4", "6"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "AbMaj9": [{
        "positions": ["x", "11", "10", "12", "11", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "6", "5", "8", "6"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "11", "8", "8", "8", "8"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["4", "3", "5", "3", "4", "3"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["4", "x", "5", "3", "4", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "AbMaj13": [{
        "positions": ["x", "11", "x", "12", "13", "13"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["4", "3", "3", "3", "4", "3"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["4", "x", "5", "5", "6", "6"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Ab+9": [{
        "positions": ["x", "11", "10", "11", "11", "12"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["4", "x", "4", "5", "5", "6"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "AbMaj7#11": [{
        "positions": ["x", "11", "12", "12", "13", "11"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["4", "x", "5", "5", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "7", "8", "8"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Ab9b5": [{
        "positions": ["x", "11", "10", "11", "11", "10"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["4", "3", "4", "3", "3", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Ab7b9": [{
        "positions": ["x", "11", "10", "11", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["4", "6", "4", "5", "4", "5"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "11", "10", "11", "10", "11"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "6", "5", "7", "5"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Ab7#9": [{
        "positions": ["x", "11", "10", "11", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["4", "6", "4", "5", "4", "7"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "6", "5", "7", "7"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Ab7b5#9": [{"positions": ["x", "11", "10", "11", "12", "10"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Ab7#11": [{"positions": ["4", "5", "4", "5", "4", "4"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Ab7b5": [{
        "positions": ["x", "11", "12", "11", "13", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["4", "x", "4", "5", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "7", "7", "8"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "11", "12", "11", "13", "14"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Abm9b5": [{"positions": ["4", "5", "4", "4", "7", "6"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Ab+7b9": [{
        "positions": ["x", "11", "10", "11", "10", "12"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["4", "x", "4", "5", "5", "5"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Ab+7#9": [{
        "positions": ["x", "11", "10", "11", "12", "12"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["4", "x", "4", "5", "5", "7"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Bb": [{
        "positions": ["x", "1", "3", "3", "3", "1"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["6", "8", "8", "7", "6", "6"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "11", "10"],
        "fingerings": [["0", "0", "1", "2", "4", "3"]]
    }, {
        "positions": ["x", "13", "15", "15", "15", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "12", "10", "11", "10"],
        "fingerings": [["0", "4", "3", "1", "2", "1"]]
    }, {"positions": ["6", "5", "3", "3", "3", "6"], "fingerings": [["3", "2", "1", "1", "1", "4"]]}],
    "Bbm": [{
        "positions": ["x", "1", "3", "3", "2", "1"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["6", "8", "8", "6", "6", "6"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "11", "9"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "13", "15", "15", "14", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["x", "x", "8", "6", "6", "6"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "Bb5": [{
        "positions": ["w", "1", "3", "3", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "8", "8", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "1", "3", "3", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "3", "6", "6"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "8", "10", "11", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Bbsus2": [{
        "positions": ["x", "1", "3", "3", "1", "1"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["6", "8", "8", "5", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "15", "15", "13", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "1", "3", "5", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "8", "5", "6", "8"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "8", "10", "11", "8"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Bbsus4": [{
        "positions": ["x", "1", "3", "3", "4", "1"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["6", "8", "8", "8", "6", "6"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "11", "11"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "8", "8", "6", "6"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Bb+": [{
        "positions": ["x", "13", "12", "11", "11", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "7", "6"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["6", "5", "4", "3", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["6", "9", "8", "7", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "1", "x", "3", "3", "2"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Bb°": [{
        "positions": ["x", "1", "2", "3", "2", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["6", "x", "8", "6", "5", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["6", "7", "8", "6", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Bb7": [{
        "positions": ["x", "1", "3", "1", "3", "1"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "6"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "7", "6", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "8", "10", "9", "10"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "13", "12", "13", "11", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "Bb7sus4": [{
        "positions": ["x", "1", "3", "1", "4", "1"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["6", "8", "6", "8", "6", "6"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "13", "13", "13", "11", "11"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {"positions": ["x", "x", "8", "10", "9", "11"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Bbm7": [{
        "positions": ["x", "1", "3", "1", "2", "1"],
        "fingerings": [["0", "1", "3", "1", "2", "1"]]
    }, {
        "positions": ["6", "8", "6", "6", "6", "6"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "6", "6", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "13", "15", "13", "14", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "8", "8", "6", "9", "6"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "13", "11", "13", "14", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "13", "11", "13", "11", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "8", "10", "9", "9"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "BbMaj7": [{
        "positions": ["x", "1", "3", "2", "3", "1"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "8", "7", "6", "5"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "10", "10"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["6", "x", "7", "7", "6", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["6", "8", "7", "7", "6", "6"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Bbm7b5": [{
        "positions": ["x", "x", "8", "9", "9", "9"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["6", "x", "6", "6", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "1", "2", "1", "2", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["6", "7", "8", "9", "9", "9"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "13", "x", "13", "14", "12"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["6", "7", "6", "6", "9", "6"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Bb°7": [{
        "positions": ["x", "1", "2", "0", "2", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "7", "5", "6", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "14", "12", "14", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "8", "9"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["6", "x", "5", "6", "5", "x"], "fingerings": [["3", "0", "1", "4", "2", "0"]]}],
    "Bb+7": [{
        "positions": ["x", "1", "4", "1", "3", "2"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["6", "x", "6", "7", "7", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "8", "11", "9", "10"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "1", "x", "1", "3", "2"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "BbmMaj7": [{
        "positions": ["x", "1", "3", "2", "2", "1"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["6", "x", "7", "6", "6", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["6", "8", "7", "6", "6", "6"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "10", "9"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "8", "6", "6", "5"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Bbadd9": [{
        "positions": ["x", "1", "3", "3", "1", "1"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "6", "8"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "1", "3", "5", "3", "1"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["6", "x", "x", "7", "6", "8"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Bbmadd9": [{"positions": ["x", "x", "8", "6", "6", "8"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Bb6": [{
        "positions": ["x", "1", "3", "3", "3", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "8", "10", "8", "10"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "x", "8", "7", "8", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "1", "3", "0", "3", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["6", "x", "5", "7", "6", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Bbm6": [{
        "positions": ["6", "8", "8", "6", "8", "6"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "8", "9"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "1", "3", "0", "2", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "x", "5", "6", "6", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "13", "11", "12", "11", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "13", "15", "12", "14", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "13", "11", "12", "11", "13"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "13", "x", "12", "14", "13"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Bbmb6": [{
        "positions": ["x", "13", "11", "11", "11", "13"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["6", "x", "4", "6", "6", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Bb9": [{
        "positions": ["x", "1", "0", "1", "1", "x"],
        "fingerings": [["0", "1", "0", "3", "4", "0"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "8"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["6", "x", "6", "5", "6", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "12", "13", "13", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["6", "x", "6", "5", "3", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "9", "8"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["6", "5", "6", "5", "6", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Bb11": [{
        "positions": ["x", "1", "1", "1", "1", "1"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "8", "6", "8", "6", "8"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "x", "6", "5", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "12", "13", "11", "11"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "1", "1", "1", "3", "1"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "8", "8", "9", "10"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Bb13": [{
        "positions": ["6", "x", "6", "5", "3", "3"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "7", "8", "8"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {
        "positions": ["x", "13", "12", "13", "13", "15"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["6", "8", "6", "7", "8", "6"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Bb9sus4": [{
        "positions": ["x", "1", "1", "1", "1", "1"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "5", "4", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["6", "x", "6", "5", "4", "4"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Bb13sus4": [{
        "positions": ["x", "1", "1", "1", "1", "3"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["6", "x", "6", "8", "8", "8"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Bbm9": [{
        "positions": ["6", "8", "6", "6", "6", "8"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "13", "11", "13", "13", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "13", "11", "13", "13", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "8", "6", "9", "8"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["6", "x", "6", "6", "6", "8"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Bbm11": [{
        "positions": ["x", "13", "11", "13", "11", "11"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "1", "1", "1", "2", "1"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["6", "x", "6", "6", "4", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "8", "9", "9"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "13", "x", "13", "14", "11"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Bbm13": [{
        "positions": ["x", "1", "x", "1", "2", "3"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["6", "8", "6", "6", "8", "6"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["6", "x", "6", "6", "8", "8"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "1", "3", "1", "2", "3"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "13", "11", "13", "13", "15"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "BbmMaj9": [{
        "positions": ["x", "13", "11", "14", "13", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["6", "8", "7", "6", "6", "8"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "BbMaj9": [{
        "positions": ["x", "13", "12", "14", "13", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "10", "8"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "13", "10", "10", "10", "10"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "5", "7", "5", "6", "5"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["6", "x", "7", "5", "6", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "BbMaj13": [{
        "positions": ["x", "1", "x", "2", "3", "3"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["6", "5", "5", "5", "6", "5"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["6", "x", "7", "7", "8", "8"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Bb+9": [{
        "positions": ["x", "13", "12", "13", "13", "14"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["6", "x", "6", "7", "7", "8"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "BbMaj7#11": [{
        "positions": ["x", "1", "2", "2", "3", "1"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["6", "x", "7", "7", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "10", "10"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Bb9b5": [{
        "positions": ["x", "13", "12", "13", "13", "12"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["6", "5", "6", "5", "5", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Bb7b9": [{
        "positions": ["x", "13", "12", "13", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "7"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "13", "12", "13", "12", "13"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "8", "7", "9", "7"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Bb7#9": [{
        "positions": ["x", "13", "12", "13", "14", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "9"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "8", "7", "9", "9"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Bb7b5#9": [{"positions": ["x", "13", "12", "13", "14", "12"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Bb7#11": [{"positions": ["6", "7", "6", "7", "6", "6"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Bb7b5": [{
        "positions": ["x", "1", "2", "1", "3", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["6", "x", "6", "7", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "9", "10"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "1", "2", "1", "3", "4"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Bbm9b5": [{"positions": ["6", "7", "6", "6", "9", "8"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Bb+7b9": [{
        "positions": ["x", "13", "12", "13", "12", "14"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["6", "x", "6", "7", "7", "7"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Bb+7#9": [{
        "positions": ["x", "13", "12", "13", "14", "14"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["6", "x", "6", "7", "7", "9"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Cb": [{
        "positions": ["x", "2", "4", "4", "4", "2"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "9", "9", "8", "7", "7"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["7", "6", "4", "4", "4", "7"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "9", "11", "12", "11"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Cbm": [{
        "positions": ["x", "2", "4", "4", "3", "2"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["7", "9", "9", "7", "7", "7"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "7", "7", "7"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "9", "11", "12", "10"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "Cb5": [{
        "positions": ["7", "9", "9", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "2", "4", "4", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "4", "7", "7"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "9", "11", "12", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Cbsus2": [{
        "positions": ["x", "2", "4", "4", "2", "2"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "4", "6", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "9", "6", "7", "9"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "9", "11", "12", "9"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Cbsus4": [{
        "positions": ["x", "2", "4", "4", "5", "2"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "9", "9", "9", "7", "7"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "12", "12"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "9", "9", "7", "7"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Cb+": [{
        "positions": ["x", "14", "13", "12", "12", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "9", "8", "8", "7"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["7", "6", "5", "4", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["7", "10", "9", "8", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "2", "x", "4", "4", "3"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Cb°": [{
        "positions": ["x", "2", "3", "4", "3", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["7", "x", "9", "7", "6", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["7", "8", "9", "7", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Cb7": [{
        "positions": ["x", "2", "4", "2", "4", "2"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "7"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "10", "11"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "14", "13", "14", "12", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["7", "x", "7", "8", "7", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "Cb7sus4": [{
        "positions": ["x", "14", "14", "14", "12", "12"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "4", "2", "5", "2"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["7", "9", "7", "9", "7", "7"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "9", "11", "10", "12"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Cbm7": [{
        "positions": ["x", "2", "4", "2", "3", "2"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["7", "9", "9", "7", "10", "7"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "7", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "14", "12", "14", "15", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["7", "9", "7", "7", "7", "7"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "14", "12", "14", "12", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "9", "11", "10", "10"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "CbMaj7": [{
        "positions": ["x", "x", "9", "8", "7", "6"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "2", "4", "3", "4", "2"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["7", "x", "8", "8", "7", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "9", "11", "11", "11"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {"positions": ["7", "9", "8", "8", "7", "7"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Cbm7b5": [{
        "positions": ["7", "x", "7", "7", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "2", "3", "2", "3", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "10", "10"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["7", "8", "9", "10", "10", "10"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "2", "x", "2", "3", "1"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["7", "8", "7", "7", "10", "7"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Cb°7": [{
        "positions": ["x", "2", "3", "1", "3", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["7", "x", "6", "7", "6", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "9", "10"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "Cb+7": [{
        "positions": ["x", "2", "5", "2", "4", "3"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["7", "x", "7", "8", "8", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "9", "12", "10", "11"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "2", "x", "2", "4", "3"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "CbmMaj7": [{
        "positions": ["x", "2", "4", "3", "3", "2"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["7", "x", "8", "7", "7", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["7", "9", "8", "7", "7", "7"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "11", "10"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "9", "7", "7", "6"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Cbadd9": [{
        "positions": ["x", "x", "9", "8", "7", "9"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "2", "4", "6", "4", "2"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["7", "x", "x", "8", "7", "9"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Cbmadd9": [{"positions": ["x", "x", "9", "7", "7", "9"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Cb6": [{
        "positions": ["x", "2", "4", "4", "4", "4"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "9", "11", "9", "11"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["7", "x", "6", "8", "7", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Cbm6": [{
        "positions": ["x", "14", "12", "13", "12", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["7", "9", "9", "7", "9", "7"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "9", "11", "9", "10"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "2", "4", "1", "3", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "14", "12", "13", "12", "14"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["7", "x", "6", "7", "7", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "2", "x", "1", "3", "2"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Cbmb6": [{
        "positions": ["x", "14", "12", "12", "12", "14"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["7", "x", "5", "7", "7", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Cb9": [{
        "positions": ["7", "9", "7", "8", "7", "9"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "2", "1", "2", "2", "2"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["7", "x", "7", "6", "4", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "8", "10", "9"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["7", "6", "7", "6", "7", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Cb11": [{
        "positions": ["x", "14", "13", "14", "12", "12"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "2", "2", "4", "2"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "9", "9", "10", "11"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Cb13": [{
        "positions": ["x", "2", "1", "2", "2", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["7", "x", "7", "6", "4", "4"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["7", "x", "7", "8", "9", "9"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["7", "9", "7", "8", "9", "7"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Cb9sus4": [{
        "positions": ["x", "2", "2", "2", "2", "2"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["7", "x", "7", "6", "5", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["7", "x", "7", "6", "5", "5"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Cb13sus4": [{
        "positions": ["x", "2", "2", "2", "2", "4"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["7", "x", "7", "9", "9", "9"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Cbm9": [{
        "positions": ["7", "9", "7", "7", "7", "9"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "14", "12", "14", "14", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "14", "12", "14", "14", "14"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "9", "7", "10", "9"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["7", "x", "7", "7", "7", "9"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Cbm11": [{
        "positions": ["x", "14", "12", "14", "12", "12"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "2", "2", "2", "3", "2"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "9", "10", "10"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "14", "x", "14", "15", "12"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Cbm13": [{
        "positions": ["x", "2", "x", "2", "3", "4"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["7", "9", "7", "7", "9", "7"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["7", "x", "7", "7", "9", "9"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "2", "4", "2", "3", "4"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "14", "12", "14", "14", "16"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "CbmMaj9": [{
        "positions": ["x", "14", "12", "15", "14", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["7", "9", "8", "7", "7", "9"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "CbMaj9": [{
        "positions": ["x", "2", "1", "3", "2", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "9", "8", "11", "9"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "14", "11", "11", "11", "11"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["7", "6", "8", "6", "7", "6"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["7", "x", "8", "6", "7", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "CbMaj13": [{
        "positions": ["x", "2", "x", "3", "4", "4"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["7", "6", "6", "6", "7", "6"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["7", "x", "8", "8", "9", "9"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Cb+9": [{
        "positions": ["x", "2", "1", "2", "2", "3"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["7", "x", "7", "8", "8", "9"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "CbMaj7#11": [{
        "positions": ["x", "2", "3", "3", "4", "2"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["7", "x", "8", "8", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "11", "11"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Cb9b5": [{
        "positions": ["x", "2", "1", "2", "2", "1"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["7", "6", "7", "6", "6", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Cb7b9": [{
        "positions": ["x", "2", "1", "2", "1", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "8"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "2", "1", "2", "1", "2"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "9", "8", "10", "8"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Cb7#9": [{
        "positions": ["x", "2", "1", "2", "3", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["7", "9", "7", "8", "7", "10"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "9", "8", "10", "10"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Cb7b5#9": [{"positions": ["x", "2", "1", "2", "3", "1"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Cb7#11": [{"positions": ["7", "8", "7", "8", "7", "7"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Cb7b5": [{
        "positions": ["x", "2", "3", "2", "4", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["7", "x", "7", "8", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "9", "10", "10", "11"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "2", "3", "2", "4", "5"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Cbm9b5": [{"positions": ["7", "8", "7", "7", "10", "9"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Cb+7b9": [{
        "positions": ["x", "2", "1", "2", "1", "3"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["7", "x", "7", "8", "8", "8"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Cb+7#9": [{
        "positions": ["x", "2", "1", "2", "3", "3"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["7", "x", "7", "8", "8", "10"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Db": [{
        "positions": ["x", "4", "6", "6", "6", "4"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["9", "11", "11", "10", "9", "9"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "4", "3", "1", "2", "1"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "8", "6", "6", "6", "9"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "11", "13", "14", "13"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Dbm": [{
        "positions": ["x", "4", "6", "6", "5", "4"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["9", "11", "11", "9", "9", "9"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "11", "9", "9", "9"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "11", "13", "14", "12"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "Db5": [{
        "positions": ["x", "4", "6", "6", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["9", "11", "11", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "6", "9", "9"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "11", "13", "14", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Dbsus2": [{
        "positions": ["x", "4", "6", "6", "4", "4"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "1", "1", "2", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "6", "8", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "8", "9", "11"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "11", "13", "14", "11"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Dbsus4": [{
        "positions": ["x", "4", "6", "6", "7", "4"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["9", "11", "11", "11", "9", "9"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "4", "1", "2", "x"],
        "fingerings": [["0", "3", "4", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "11", "13", "14", "14"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "11", "11", "9", "9"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Db+": [{
        "positions": ["x", "4", "3", "2", "2", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "10", "9"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["9", "8", "7", "6", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["9", "12", "11", "10", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "4", "x", "6", "6", "5"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Db°": [{
        "positions": ["x", "4", "5", "6", "5", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["9", "x", "11", "9", "8", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["9", "10", "11", "9", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Db7": [{
        "positions": ["x", "4", "6", "4", "6", "4"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "9"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "10", "9", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "11", "13", "12", "13"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "4", "3", "4", "2", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "Db7sus4": [{
        "positions": ["x", "4", "4", "4", "2", "2"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["9", "11", "9", "11", "9", "9"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "6", "4", "7", "4"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "11", "13", "12", "14"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Dbm7": [{
        "positions": ["x", "4", "6", "4", "5", "4"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["9", "11", "11", "9", "12", "9"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["9", "x", "9", "9", "9", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "4", "2", "4", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["9", "11", "9", "9", "9", "9"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "4", "2", "4", "2", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "11", "13", "12", "12"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "DbMaj7": [{
        "positions": ["x", "4", "6", "5", "6", "4"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "11", "10", "9", "8"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "11", "13", "13", "13"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "4", "3", "1", "1", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "x", "10", "10", "9", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["9", "11", "10", "10", "9", "9"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Dbm7b5": [{
        "positions": ["x", "4", "5", "4", "5", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["9", "x", "9", "9", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["9", "10", "11", "12", "12", "12"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "x", "11", "12", "12", "12"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "4", "x", "4", "5", "3"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["9", "10", "9", "9", "12", "9"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Db°7": [{
        "positions": ["x", "4", "5", "3", "5", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["9", "10", "8", "9", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "x", "8", "9", "8", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "11", "12", "11", "12"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "Db+7": [{
        "positions": ["x", "4", "7", "4", "6", "5"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["9", "x", "9", "10", "10", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "11", "14", "12", "13"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "4", "x", "4", "6", "5"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "DbmMaj7": [{
        "positions": ["x", "4", "6", "5", "5", "4"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["9", "x", "10", "9", "9", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["9", "11", "10", "9", "9", "9"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "11", "13", "13", "12"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "11", "9", "9", "8"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Dbadd9": [{
        "positions": ["x", "4", "6", "6", "4", "4"],
        "fingerings": [["0", "1", "2", "3", "1", "1"], ["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "11", "10", "9", "11"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "4", "1", "1", "2", "1"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "6", "8", "6", "4"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["9", "x", "x", "10", "9", "11"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Dbmadd9": [{"positions": ["x", "x", "11", "9", "9", "11"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Db6": [{
        "positions": ["x", "4", "6", "6", "6", "6"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["0", "0", "11", "10", "11", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "13", "11", "13"],
        "fingerings": [["0", "0", "1", "2", "1", "3"], ["0", "0", "1", "3", "1", "4"]]
    }, {"positions": ["9", "x", "8", "10", "9", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Dbm6": [{
        "positions": ["x", "4", "2", "3", "2", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["9", "11", "11", "9", "11", "9"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "11", "13", "11", "12"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "4", "6", "3", "5", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "4", "2", "3", "2", "4"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["9", "x", "8", "9", "9", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "4", "x", "3", "5", "4"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Dbmb6": [{
        "positions": ["x", "4", "2", "2", "2", "4"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["9", "x", "7", "9", "9", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Db9": [{
        "positions": ["x", "4", "3", "4", "4", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "11"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["9", "x", "9", "8", "9", "9"],
        "fingerings": [["2", "0", "3", "1", "4", "4"]]
    }, {
        "positions": ["x", "4", "3", "4", "4", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["9", "x", "9", "8", "6", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "12", "11"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["9", "8", "9", "8", "9", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Db11": [{
        "positions": ["x", "4", "x", "4", "4", "3"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "4", "4", "4", "4"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "8", "7", "7"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "3", "4", "2", "2"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "4", "4", "6", "4"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "11", "11", "12", "13"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Db13": [{
        "positions": ["x", "4", "3", "4", "4", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["9", "x", "9", "8", "6", "6"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "10", "11", "11"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["9", "11", "9", "10", "11", "9"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Db9sus4": [{
        "positions": ["x", "4", "4", "4", "4", "4"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "8", "7", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["9", "x", "9", "8", "7", "7"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Db13sus4": [{
        "positions": ["x", "4", "4", "4", "4", "6"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["9", "x", "9", "11", "11", "11"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Dbm9": [{
        "positions": ["9", "11", "9", "9", "9", "11"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "4", "2", "4", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "4", "2", "4", "4", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "11", "9", "12", "11"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["9", "x", "9", "9", "9", "11"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Dbm11": [{
        "positions": ["x", "4", "2", "4", "2", "2"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "4", "4", "5", "4"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["9", "x", "9", "9", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "11", "12", "12"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "4", "x", "4", "5", "2"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Dbm13": [{
        "positions": ["x", "4", "x", "4", "5", "6"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["9", "11", "9", "9", "11", "9"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["9", "x", "9", "9", "11", "11"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "4", "6", "4", "5", "6"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "4", "2", "4", "4", "6"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "DbmMaj9": [{
        "positions": ["x", "4", "2", "5", "4", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["9", "11", "10", "9", "9", "11"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "DbMaj9": [{
        "positions": ["x", "4", "3", "5", "4", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "13", "11"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "4", "1", "1", "1", "1"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["9", "8", "10", "8", "9", "8"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["9", "x", "10", "8", "9", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "DbMaj13": [{
        "positions": ["x", "4", "x", "5", "6", "6"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["9", "8", "8", "8", "9", "8"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["9", "x", "10", "10", "11", "11"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Db+9": [{
        "positions": ["x", "4", "3", "4", "4", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["9", "x", "9", "10", "10", "11"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "DbMaj7#11": [{
        "positions": ["x", "4", "5", "5", "6", "4"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["9", "x", "10", "10", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "12", "13", "13"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Db9b5": [{
        "positions": ["x", "4", "3", "4", "4", "3"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["9", "8", "9", "8", "8", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Db7b9": [{
        "positions": ["x", "4", "3", "4", "3", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "10"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "4", "3", "4", "3", "4"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "11", "10", "12", "10"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Db7#9": [{
        "positions": ["x", "4", "3", "4", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "12"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "11", "10", "12", "12"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Db7b5#9": [{"positions": ["x", "4", "3", "4", "5", "3"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Db7#11": [{"positions": ["9", "10", "9", "10", "9", "9"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Db7b5": [{
        "positions": ["x", "4", "5", "4", "6", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["9", "x", "9", "10", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "12", "12", "13"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "4", "5", "4", "6", "7"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Dbm9b5": [{"positions": ["9", "10", "9", "9", "12", "11"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Db+7b9": [{
        "positions": ["x", "4", "3", "4", "3", "5"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["9", "x", "9", "10", "10", "10"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Db+7#9": [{
        "positions": ["x", "4", "3", "4", "5", "5"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["9", "x", "9", "10", "10", "12"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Eb": [{
        "positions": ["x", "6", "8", "8", "8", "6"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "6", "5", "3", "4", "3"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "1", "3", "4", "3"],
        "fingerings": [["0", "0", "1", "2", "4", "3"]]
    }, {
        "positions": ["11", "13", "13", "12", "11", "11"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {"positions": ["11", "10", "8", "8", "8", "11"], "fingerings": [["3", "2", "1", "1", "1", "4"]]}],
    "Ebm": [{
        "positions": ["x", "6", "8", "8", "7", "6"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["x", "x", "1", "3", "4", "2"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["11", "13", "13", "11", "11", "11"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {"positions": ["x", "x", "13", "11", "11", "11"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "Eb5": [{
        "positions": ["x", "6", "8", "8", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["11", "13", "13", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "8", "11", "11"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "1", "3", "4", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Ebsus2": [{
        "positions": ["x", "x", "1", "3", "4", "1"],
        "fingerings": [["0", "0", "1", "3", "4", "1"]]
    }, {
        "positions": ["x", "6", "8", "8", "6", "6"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "8", "10", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {"positions": ["x", "x", "13", "10", "11", "13"], "fingerings": [["0", "0", "3", "1", "2", "4"]]}],
    "Ebsus4": [{
        "positions": ["x", "6", "8", "8", "9", "6"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "6", "6", "3", "4", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "8", "8", "9", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "13", "13", "13", "11", "11"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "1", "3", "4", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "13", "13", "11", "11"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Eb+": [{
        "positions": ["x", "6", "5", "4", "4", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "12", "11"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["11", "10", "9", "8", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["11", "14", "13", "12", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "6", "x", "8", "8", "7"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Eb°": [{
        "positions": ["x", "6", "7", "8", "7", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["11", "x", "13", "11", "10", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["11", "12", "13", "11", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Eb7": [{
        "positions": ["x", "x", "1", "3", "2", "3"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "6", "8", "6", "8", "6"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["11", "x", "11", "12", "11", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "6", "5", "6", "4", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["11", "13", "11", "12", "11", "11"], "fingerings": [["1", "3", "1", "2", "1", "1"]]}],
    "Eb7sus4": [{
        "positions": ["x", "6", "6", "6", "4", "4"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "8", "6", "9", "6"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["11", "13", "11", "13", "11", "11"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "1", "3", "2", "4"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Ebm7": [{
        "positions": ["x", "x", "1", "3", "2", "2"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {
        "positions": ["x", "6", "8", "6", "7", "6"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["11", "x", "11", "11", "11", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["11", "13", "11", "11", "14", "11"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "4", "6", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["11", "13", "13", "11", "14", "11"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["11", "13", "11", "11", "11", "11"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {"positions": ["x", "6", "4", "6", "4", "x"], "fingerings": [["0", "3", "1", "4", "1", "0"]]}],
    "EbMaj7": [{
        "positions": ["x", "x", "1", "3", "3", "3"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "6", "8", "7", "8", "6"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "13", "15", "15", "15"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "5", "3", "3", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "11", "10"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["11", "x", "12", "12", "11", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["11", "13", "12", "12", "11", "11"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Ebm7b5": [{
        "positions": ["x", "6", "7", "6", "7", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "2", "2"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["11", "x", "11", "11", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["11", "12", "13", "14", "14", "14"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "6", "x", "6", "7", "5"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["11", "12", "11", "11", "14", "11"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Eb°7": [{
        "positions": ["x", "6", "7", "5", "7", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "1", "2"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["11", "x", "10", "11", "10", "x"], "fingerings": [["3", "0", "1", "4", "2", "0"]]}],
    "Eb+7": [{
        "positions": ["x", "6", "9", "6", "8", "7"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["11", "x", "11", "12", "12", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "1", "4", "2", "3"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "6", "x", "6", "8", "7"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "EbmMaj7": [{
        "positions": ["x", "6", "8", "7", "7", "6"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["11", "x", "12", "11", "11", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["11", "13", "12", "11", "11", "11"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "1", "3", "3", "2"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "13", "11", "11", "10"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Ebadd9": [{
        "positions": ["x", "6", "8", "8", "6", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "11", "13"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "6", "8", "10", "8", "6"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["11", "x", "x", "12", "11", "13"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Ebmadd9": [{"positions": ["x", "x", "13", "11", "11", "13"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Eb6": [{
        "positions": ["x", "x", "1", "3", "1", "3"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "6", "8", "8", "8", "8"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "13", "15", "13", "15"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["11", "x", "10", "12", "11", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Ebm6": [{
        "positions": ["x", "x", "1", "3", "1", "2"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "6", "4", "5", "4", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "x", "13", "15", "13", "14"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "8", "5", "7", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["11", "13", "13", "11", "13", "11"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "6", "4", "5", "4", "6"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["11", "x", "10", "11", "11", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "6", "x", "5", "7", "6"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Ebmb6": [{
        "positions": ["x", "6", "4", "4", "4", "6"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["11", "x", "9", "11", "11", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Eb9": [{
        "positions": ["x", "6", "5", "6", "6", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "x", "11", "10", "11", "11"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "13", "11", "12", "11", "13"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "6", "5", "6", "6", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["11", "x", "11", "10", "8", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "14", "13"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["11", "10", "11", "10", "11", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Eb11": [{
        "positions": ["x", "6", "6", "6", "6", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "x", "6", "6", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "x", "11", "10", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "5", "6", "4", "4"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "6", "6", "8", "6"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "1", "1", "2", "3"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Eb13": [{
        "positions": ["x", "6", "5", "6", "6", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["11", "x", "11", "10", "8", "8"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["11", "x", "11", "12", "13", "13"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["11", "13", "11", "12", "13", "11"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Eb9sus4": [{
        "positions": ["x", "6", "6", "6", "6", "6"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["11", "x", "11", "10", "9", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["11", "x", "11", "10", "9", "9"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Eb13sus4": [{
        "positions": ["x", "6", "6", "6", "6", "8"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["11", "x", "11", "13", "13", "13"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Ebm9": [{
        "positions": ["x", "6", "4", "6", "6", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["11", "13", "11", "11", "11", "13"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "6", "4", "6", "6", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "13", "11", "14", "13"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["11", "x", "11", "11", "11", "13"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Ebm11": [{
        "positions": ["x", "6", "4", "6", "4", "4"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "6", "6", "7", "6"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["11", "x", "11", "11", "9", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "1", "1", "2", "2"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "6", "x", "6", "7", "4"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Ebm13": [{
        "positions": ["x", "6", "x", "6", "7", "8"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["11", "13", "11", "11", "13", "11"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["11", "x", "11", "11", "13", "13"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "6", "8", "6", "7", "8"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "6", "4", "6", "6", "8"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "EbmMaj9": [{
        "positions": ["x", "6", "4", "7", "6", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["11", "13", "12", "11", "11", "13"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "EbMaj9": [{
        "positions": ["x", "6", "5", "7", "6", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "15", "13"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "6", "3", "3", "3", "3"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["11", "10", "12", "10", "11", "10"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["11", "x", "12", "10", "11", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "EbMaj13": [{
        "positions": ["x", "6", "x", "7", "8", "8"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["11", "10", "10", "10", "11", "10"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["11", "x", "12", "12", "13", "13"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Eb+9": [{
        "positions": ["x", "6", "5", "6", "6", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["11", "x", "11", "12", "12", "13"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "EbMaj7#11": [{
        "positions": ["x", "6", "7", "7", "8", "6"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["11", "x", "12", "12", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "3", "3"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Eb9b5": [{
        "positions": ["x", "6", "5", "6", "6", "5"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["11", "10", "11", "10", "10", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Eb7b9": [{
        "positions": ["x", "6", "5", "6", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["11", "13", "11", "12", "11", "12"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "6", "5", "6", "5", "6"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "13", "12", "14", "12"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Eb7#9": [{
        "positions": ["x", "6", "5", "6", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["11", "13", "11", "12", "11", "14"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "13", "12", "14", "14"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Eb7b5#9": [{"positions": ["x", "6", "5", "6", "7", "5"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Eb7#11": [{"positions": ["11", "12", "11", "12", "11", "11"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Eb7b5": [{
        "positions": ["x", "6", "7", "6", "8", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["11", "x", "11", "12", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "2", "3"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "6", "7", "6", "8", "9"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Ebm9b5": [{"positions": ["11", "12", "11", "11", "14", "13"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Eb+7b9": [{
        "positions": ["x", "6", "5", "6", "5", "7"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["11", "x", "11", "12", "12", "12"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Eb+7#9": [{
        "positions": ["x", "6", "5", "6", "7", "7"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["11", "x", "11", "12", "12", "14"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Fb": [{
        "positions": ["x", "7", "9", "9", "9", "7"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["12", "14", "14", "13", "12", "12"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["12", "11", "9", "9", "9", "12"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "2", "4", "5", "4"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Fbm": [{
        "positions": ["x", "7", "9", "9", "8", "7"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["12", "14", "14", "12", "12", "12"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "14", "12", "12", "12"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "2", "4", "5", "3"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "Fb5": [{
        "positions": ["12", "14", "14", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "7", "9", "9", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "9", "12", "12"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "2", "4", "5", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Fbsus2": [{
        "positions": ["x", "7", "9", "9", "7", "7"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "9", "11", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "14", "11", "12", "14"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "2", "4", "5", "2"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "Fbsus4": [{
        "positions": ["x", "7", "9", "9", "10", "7"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["12", "14", "14", "14", "12", "12"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "2", "4", "5", "5"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "14", "14", "12", "12"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Fb+": [{
        "positions": ["x", "7", "6", "5", "5", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "14", "13", "13", "12"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["12", "11", "10", "9", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["12", "15", "14", "13", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "7", "x", "9", "9", "8"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Fb°": [{
        "positions": ["x", "7", "8", "9", "8", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["12", "x", "14", "12", "11", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["12", "13", "14", "12", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Fb7": [{
        "positions": ["x", "7", "9", "7", "9", "7"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "12"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "2", "4", "3", "4"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "7", "6", "7", "5", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["12", "x", "12", "13", "12", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "Fb7sus4": [{
        "positions": ["x", "7", "7", "7", "5", "5"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "9", "7", "10", "7"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["12", "14", "12", "14", "12", "12"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "2", "4", "3", "5"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Fbm7": [{
        "positions": ["x", "7", "9", "7", "8", "7"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["12", "14", "14", "12", "15", "12"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["12", "x", "12", "12", "12", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "7", "5", "7", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["12", "14", "12", "12", "12", "12"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "7", "5", "7", "5", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "2", "4", "3", "3"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "FbMaj7": [{
        "positions": ["x", "x", "14", "13", "12", "11"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "7", "9", "8", "9", "7"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["12", "x", "13", "13", "12", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "2", "4", "4", "4"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {"positions": ["12", "14", "13", "13", "12", "12"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Fbm7b5": [{
        "positions": ["12", "x", "12", "12", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "7", "8", "7", "8", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "3", "3"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["12", "13", "14", "15", "15", "15"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "7", "x", "7", "8", "6"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["12", "13", "12", "12", "15", "12"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Fb°7": [{
        "positions": ["x", "7", "8", "6", "8", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["12", "x", "11", "12", "11", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "2", "3"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "Fb+7": [{
        "positions": ["x", "7", "10", "7", "9", "8"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["12", "x", "12", "13", "13", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "2", "5", "3", "4"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "7", "x", "7", "9", "8"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "FbmMaj7": [{
        "positions": ["x", "7", "9", "8", "8", "7"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["12", "x", "13", "12", "12", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["12", "14", "13", "12", "12", "12"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "2", "4", "4", "3"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "14", "12", "12", "11"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Fbadd9": [{
        "positions": ["x", "x", "14", "13", "12", "14"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "7", "9", "11", "9", "7"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["12", "x", "x", "13", "12", "14"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Fbmadd9": [{"positions": ["x", "x", "14", "12", "12", "14"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Fb6": [{
        "positions": ["x", "7", "9", "9", "9", "9"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "2", "4", "2", "4"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["12", "x", "11", "13", "12", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Fbm6": [{
        "positions": ["x", "7", "5", "6", "5", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["12", "14", "14", "12", "14", "12"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "2", "4", "2", "3"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "7", "9", "6", "8", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "7", "5", "6", "5", "7"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["12", "x", "11", "12", "12", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "7", "x", "6", "8", "7"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Fbmb6": [{
        "positions": ["x", "7", "5", "5", "5", "7"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["12", "x", "10", "12", "12", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Fb9": [{
        "positions": ["12", "14", "12", "13", "12", "14"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "7", "6", "7", "7", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["12", "x", "12", "11", "9", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "1", "3", "2"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["12", "11", "12", "11", "12", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Fb11": [{
        "positions": ["x", "7", "6", "7", "5", "5"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "7", "7", "9", "7"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "2", "2", "3", "4"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Fb13": [{
        "positions": ["x", "7", "6", "7", "7", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["12", "x", "12", "11", "9", "9"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["12", "x", "12", "13", "14", "14"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["12", "14", "12", "13", "14", "12"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Fb9sus4": [{
        "positions": ["x", "7", "7", "7", "7", "7"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["12", "x", "12", "11", "10", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["12", "x", "12", "11", "10", "10"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Fb13sus4": [{
        "positions": ["x", "7", "7", "7", "7", "9"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["12", "x", "12", "14", "14", "14"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Fbm9": [{
        "positions": ["12", "14", "12", "12", "12", "14"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "7", "5", "7", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "7", "5", "7", "7", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "14", "12", "15", "14"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["12", "x", "12", "12", "12", "14"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Fbm11": [{
        "positions": ["x", "7", "5", "7", "5", "5"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "7", "7", "7", "8", "7"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["12", "x", "12", "12", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "2", "3", "3"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "7", "x", "7", "8", "5"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Fbm13": [{
        "positions": ["x", "7", "x", "7", "8", "9"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["12", "14", "12", "12", "14", "12"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["12", "x", "12", "12", "14", "14"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "7", "9", "7", "8", "9"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "7", "5", "7", "7", "9"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "FbmMaj9": [{
        "positions": ["x", "7", "5", "8", "7", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["12", "14", "13", "12", "12", "14"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "FbMaj9": [{
        "positions": ["x", "7", "6", "8", "7", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "2", "1", "4", "2"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "7", "4", "4", "4", "4"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["12", "11", "13", "11", "12", "11"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["12", "x", "13", "11", "12", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "FbMaj13": [{
        "positions": ["x", "7", "x", "8", "9", "9"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["12", "11", "11", "11", "12", "11"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["12", "x", "13", "13", "14", "14"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Fb+9": [{
        "positions": ["x", "7", "6", "7", "7", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["12", "x", "12", "13", "13", "14"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "FbMaj7#11": [{
        "positions": ["x", "7", "8", "8", "9", "7"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["12", "x", "13", "13", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "4", "4"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Fb9b5": [{
        "positions": ["x", "7", "6", "7", "7", "6"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["12", "11", "12", "11", "11", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Fb7b9": [{
        "positions": ["x", "7", "6", "7", "6", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "13"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "7", "6", "7", "6", "7"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "2", "1", "3", "1"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Fb7#9": [{
        "positions": ["x", "7", "6", "7", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["12", "14", "12", "13", "12", "15"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "2", "1", "3", "3"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Fb7b5#9": [{"positions": ["x", "7", "6", "7", "8", "6"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Fb7#11": [{"positions": ["12", "13", "12", "13", "12", "12"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Fb7b5": [{
        "positions": ["x", "7", "8", "7", "9", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["12", "x", "12", "13", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "2", "3", "3", "4"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "7", "8", "7", "9", "10"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Fbm9b5": [{"positions": ["12", "13", "12", "12", "15", "14"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Fb+7b9": [{
        "positions": ["x", "7", "6", "7", "6", "8"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["12", "x", "12", "13", "13", "13"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Fb+7#9": [{
        "positions": ["x", "7", "6", "7", "8", "8"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["12", "x", "12", "13", "13", "15"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "Gb": [{
        "positions": ["2", "4", "4", "3", "2", "2"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "11", "11", "9"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "9", "8", "6", "7", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "2", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["14", "13", "11", "11", "11", "14"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "4", "6", "7", "6"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "Gbm": [{
        "positions": ["2", "4", "4", "2", "2", "2"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "11", "10", "9"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "7", "5"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "4", "2", "2", "2"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "Gb5": [{
        "positions": ["2", "4", "4", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "11", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "11", "14", "14"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "4", "6", "7", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "Gbsus2": [{
        "positions": ["2", "4", "4", "1", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "4", "1", "2", "4"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {
        "positions": ["2", "x", "2", "1", "2", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "11", "9", "9"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "7", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "1"]]
    }, {"positions": ["x", "9", "11", "13", "x", "x"], "fingerings": [["0", "1", "3", "4", "0", "0"]]}],
    "Gbsus4": [{
        "positions": ["2", "4", "4", "4", "2", "2"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "11", "12", "9"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "9", "9", "6", "7", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "4", "6", "7", "7"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "4", "4", "2", "2"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "Gb+": [{
        "positions": ["x", "9", "8", "7", "7", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "3", "2"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["14", "13", "12", "11", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["2", "5", "4", "3", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "9", "x", "11", "11", "10"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "Gb°": [{
        "positions": ["x", "9", "10", "11", "10", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["2", "x", "4", "2", "1", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["2", "3", "4", "2", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "Gb7": [{
        "positions": ["2", "4", "2", "3", "2", "2"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "9", "10", "9", "10", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["2", "x", "2", "3", "2", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "4", "6", "5", "6"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "9", "8", "9", "7", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["x", "9", "11", "9", "11", "9"], "fingerings": [["0", "1", "3", "1", "4", "1"]]}],
    "Gb7sus4": [{
        "positions": ["2", "4", "2", "4", "2", "2"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "9", "9", "7", "7"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "9", "12", "9"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "4", "6", "5", "7"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "Gbm7": [{
        "positions": ["2", "4", "2", "2", "2", "2"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["2", "x", "2", "2", "2", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "9", "11", "9", "10", "9"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["x", "9", "7", "9", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["2", "4", "4", "2", "5", "2"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "9", "7", "9", "7", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "4", "6", "5", "5"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "GbMaj7": [{
        "positions": ["x", "x", "4", "3", "2", "1"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "9", "11", "10", "11", "9"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "6", "6"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["2", "x", "3", "3", "2", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "9", "8", "6", "6", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["2", "4", "3", "3", "2", "2"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "Gbm7b5": [{
        "positions": ["2", "x", "2", "2", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "5", "5"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "9", "10", "9", "10", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["2", "3", "4", "5", "5", "5"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "9", "x", "9", "10", "8"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["2", "3", "2", "2", "5", "2"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "Gb°7": [{
        "positions": ["2", "3", "1", "2", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "10", "8", "10", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["2", "x", "1", "2", "1", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "4", "5"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["2", "3", "4", "2", "4", "2"], "fingerings": [["0", "0", "0", "0", "0", "0"]]}],
    "Gb+7": [{
        "positions": ["x", "9", "12", "9", "11", "10"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["2", "x", "2", "3", "3", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "4", "7", "5", "6"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "9", "x", "9", "11", "10"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "GbmMaj7": [{
        "positions": ["x", "9", "11", "10", "10", "9"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["2", "x", "3", "2", "2", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["2", "4", "3", "2", "2", "2"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "6", "5"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "4", "2", "2", "1"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "Gbadd9": [{
        "positions": ["x", "x", "4", "3", "2", "4"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "9", "11", "11", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "13", "11", "9"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["2", "x", "x", "3", "2", "4"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "Gbmadd9": [{"positions": ["x", "x", "4", "2", "2", "4"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "Gb6": [{
        "positions": ["x", "x", "4", "3", "4", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "11", "11", "11"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "4", "6", "4", "6"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["2", "x", "1", "3", "2", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "Gbm6": [{
        "positions": ["2", "4", "4", "2", "4", "2"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "4", "5"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "9", "7", "8", "7", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["2", "x", "1", "2", "2", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "9", "11", "8", "10", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "9", "7", "8", "7", "9"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "9", "x", "8", "10", "9"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "Gbmb6": [{
        "positions": ["x", "9", "7", "7", "7", "9"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["14", "x", "12", "14", "14", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "Gb9": [{
        "positions": ["2", "1", "2", "3", "2", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "8", "9", "9", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["2", "4", "2", "3", "2", "4"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "9", "8", "9", "9", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["14", "x", "14", "13", "11", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "5", "4"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["2", "1", "2", "1", "2", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "Gb11": [{
        "positions": ["2", "4", "2", "4", "2", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "9", "9", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["2", "x", "2", "1", "0", "0"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "8", "9", "7", "7"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "9", "9", "11", "9"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "4", "4", "5", "6"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "Gb13": [{
        "positions": ["2", "x", "2", "3", "4", "4"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {
        "positions": ["x", "9", "8", "9", "9", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["14", "x", "14", "13", "11", "11"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {"positions": ["2", "4", "2", "3", "4", "2"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "Gb9sus4": [{
        "positions": ["x", "9", "9", "9", "9", "9"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["14", "x", "14", "13", "12", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["14", "x", "14", "13", "12", "12"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "Gb13sus4": [{
        "positions": ["x", "9", "9", "9", "9", "11"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["2", "x", "2", "4", "4", "4"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "Gbm9": [{
        "positions": ["2", "4", "2", "2", "2", "4"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "9", "7", "9", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "9", "7", "9", "9", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "4", "2", "5", "4"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["2", "x", "2", "2", "2", "4"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "Gbm11": [{
        "positions": ["x", "9", "7", "9", "7", "7"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "9", "9", "10", "9"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["14", "x", "14", "14", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "4", "5", "5"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "9", "x", "9", "10", "7"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "Gbm13": [{
        "positions": ["x", "9", "x", "9", "10", "11"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["2", "4", "2", "2", "4", "2"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["2", "x", "2", "2", "4", "4"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "9", "11", "9", "10", "11"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "9", "7", "9", "9", "11"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "GbmMaj9": [{
        "positions": ["x", "9", "7", "10", "9", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["2", "4", "3", "2", "2", "4"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "GbMaj9": [{
        "positions": ["x", "9", "8", "10", "9", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "6", "4"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "9", "6", "6", "6", "6"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["2", "1", "3", "1", "2", "1"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["2", "x", "3", "1", "2", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "GbMaj13": [{
        "positions": ["x", "9", "x", "10", "11", "11"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["2", "1", "1", "1", "2", "1"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["2", "x", "3", "3", "4", "4"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "Gb+9": [{
        "positions": ["x", "9", "8", "9", "9", "10"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["2", "x", "2", "3", "3", "4"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "GbMaj7#11": [{
        "positions": ["x", "9", "10", "10", "11", "9"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["2", "x", "3", "3", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "6", "6"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "Gb9b5": [{
        "positions": ["x", "9", "8", "9", "9", "8"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["2", "1", "2", "1", "1", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "Gb7b9": [{
        "positions": ["x", "9", "8", "9", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["2", "4", "2", "3", "2", "3"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "9", "8", "9", "8", "9"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "4", "3", "5", "3"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "Gb7#9": [{
        "positions": ["x", "9", "8", "9", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["2", "4", "2", "3", "2", "5"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "4", "3", "5", "5"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "Gb7b5#9": [{"positions": ["x", "9", "8", "9", "10", "8"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "Gb7#11": [{"positions": ["2", "3", "2", "3", "2", "2"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "Gb7b5": [{
        "positions": ["x", "9", "10", "9", "11", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["2", "x", "2", "3", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "5", "6"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "9", "10", "9", "11", "12"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "Gbm9b5": [{"positions": ["2", "3", "2", "2", "5", "4"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "Gb+7b9": [{
        "positions": ["x", "9", "8", "9", "8", "10"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["2", "x", "2", "3", "3", "3"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "Gb+7#9": [{
        "positions": ["x", "9", "8", "9", "10", "10"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["2", "x", "2", "3", "3", "5"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "A#": [{
        "positions": ["x", "1", "3", "3", "3", "1"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["6", "8", "8", "7", "6", "6"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "11", "10"],
        "fingerings": [["0", "0", "1", "2", "4", "3"]]
    }, {
        "positions": ["x", "13", "15", "15", "15", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "12", "10", "11", "10"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["6", "5", "3", "3", "3", "6"], "fingerings": [["3", "2", "1", "1", "1", "4"]]}],
    "A#m": [{
        "positions": ["x", "1", "3", "3", "2", "1"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["6", "8", "8", "6", "6", "6"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "11", "9"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "13", "15", "15", "14", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["x", "x", "8", "6", "6", "6"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "A#5": [{
        "positions": ["x", "1", "3", "3", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["6", "8", "8", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "3", "6", "6"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "8", "10", "11", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "A#sus2": [{
        "positions": ["x", "1", "3", "3", "1", "1"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["6", "8", "8", "5", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "15", "15", "13", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "1", "3", "5", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "8", "5", "6", "8"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "8", "10", "11", "8"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "A#sus4": [{
        "positions": ["x", "1", "3", "3", "4", "1"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["6", "8", "8", "8", "6", "6"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "11", "11"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "8", "8", "6", "6"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "A#+": [{
        "positions": ["x", "13", "12", "11", "11", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "7", "6"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["6", "5", "4", "3", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["6", "9", "8", "7", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "1", "x", "3", "3", "2"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "A#°": [{
        "positions": ["x", "1", "2", "3", "2", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["6", "x", "8", "6", "5", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["6", "7", "8", "6", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "A#7": [{
        "positions": ["x", "1", "3", "1", "3", "1"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "6"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "7", "6", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "8", "10", "9", "10"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "13", "12", "13", "11", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "A#7sus4": [{
        "positions": ["x", "1", "3", "1", "4", "1"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["6", "8", "6", "8", "6", "6"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "13", "13", "13", "11", "11"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {"positions": ["x", "x", "8", "10", "9", "11"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "A#m7": [{
        "positions": ["x", "1", "3", "1", "2", "1"],
        "fingerings": [["0", "1", "3", "1", "2", "1"]]
    }, {
        "positions": ["6", "8", "6", "6", "6", "6"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "6", "6", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "13", "15", "13", "14", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "8", "8", "6", "9", "6"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "13", "11", "13", "14", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "13", "11", "13", "11", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "8", "10", "9", "9"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "A#Maj7": [{
        "positions": ["x", "1", "3", "2", "3", "1"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "8", "7", "6", "5"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "10", "10"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["6", "x", "7", "7", "6", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["6", "8", "7", "7", "6", "6"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "A#m7b5": [{
        "positions": ["6", "x", "6", "6", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "1", "2", "1", "2", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "9", "9"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["6", "7", "8", "9", "9", "9"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "13", "x", "13", "14", "12"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["6", "7", "6", "6", "9", "6"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "A#°7": [{
        "positions": ["6", "x", "5", "6", "5", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "1", "2", "0", "2", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "7", "5", "6", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "8", "9"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["x", "13", "14", "12", "14", "x"], "fingerings": [["0", "2", "3", "1", "4", "0"]]}],
    "A#+7": [{
        "positions": ["x", "1", "4", "1", "3", "2"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["6", "x", "6", "7", "7", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "8", "11", "9", "10"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "1", "x", "1", "3", "2"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "A#mMaj7": [{
        "positions": ["x", "1", "3", "2", "2", "1"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["6", "x", "7", "6", "6", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["6", "8", "7", "6", "6", "6"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "10", "9"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "8", "6", "6", "5"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "A#add9": [{
        "positions": ["x", "x", "8", "7", "6", "8"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "1", "3", "5", "3", "1"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["6", "x", "x", "7", "6", "8"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "A#madd9": [{"positions": ["x", "x", "8", "6", "6", "8"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "A#6": [{
        "positions": ["x", "1", "3", "3", "3", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "8", "10", "8", "10"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "x", "8", "7", "8", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "1", "3", "0", "3", "x"],
        "fingerings": [["0", "1", "3", "0", "4", "0"]]
    }, {"positions": ["6", "x", "5", "7", "6", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "A#m6": [{
        "positions": ["6", "8", "8", "6", "8", "6"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "8", "10", "8", "9"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "1", "3", "0", "2", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "x", "5", "6", "6", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "13", "11", "12", "11", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "13", "15", "12", "14", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "13", "11", "12", "11", "13"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "13", "x", "12", "14", "13"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "A#mb6": [{
        "positions": ["x", "13", "11", "11", "11", "13"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["6", "x", "4", "6", "6", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "A#9": [{
        "positions": ["x", "1", "0", "1", "1", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "8"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["6", "x", "6", "5", "6", "6"],
        "fingerings": [["2", "0", "3", "1", "4", "4"]]
    }, {
        "positions": ["x", "13", "12", "13", "13", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["6", "x", "6", "5", "3", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "9", "8"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["6", "5", "6", "5", "6", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "A#11": [{
        "positions": ["x", "1", "1", "1", "1", "1"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "8", "6", "8", "6", "8"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["6", "x", "6", "5", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "13", "12", "13", "11", "11"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "1", "1", "1", "3", "1"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "8", "8", "9", "10"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "A#13": [{
        "positions": ["6", "x", "6", "5", "3", "3"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "7", "8", "8"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {
        "positions": ["x", "13", "12", "13", "13", "15"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["6", "8", "6", "7", "8", "6"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "A#9sus4": [{
        "positions": ["x", "1", "1", "1", "1", "1"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "x", "6", "5", "4", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["6", "x", "6", "5", "4", "4"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "A#13sus4": [{
        "positions": ["x", "1", "1", "1", "1", "3"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["6", "x", "6", "8", "8", "8"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "A#m9": [{
        "positions": ["6", "8", "6", "6", "6", "8"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "13", "11", "13", "13", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "13", "11", "13", "13", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "8", "6", "9", "8"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["6", "x", "6", "6", "6", "8"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "A#m11": [{
        "positions": ["x", "13", "11", "13", "11", "11"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "1", "1", "1", "2", "1"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["6", "x", "6", "6", "4", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "8", "9", "9"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "13", "x", "13", "14", "11"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "A#m13": [{
        "positions": ["x", "1", "x", "1", "2", "3"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["6", "8", "6", "6", "8", "6"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["6", "x", "6", "6", "8", "8"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "1", "3", "1", "2", "3"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "13", "11", "13", "13", "15"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "A#mMaj9": [{
        "positions": ["x", "13", "11", "14", "13", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["6", "8", "7", "6", "6", "8"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "A#Maj9": [{
        "positions": ["x", "13", "12", "14", "13", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "8", "7", "10", "8"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "13", "10", "10", "10", "10"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["6", "5", "7", "5", "6", "5"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["6", "x", "7", "5", "6", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "A#Maj13": [{
        "positions": ["x", "1", "x", "2", "3", "3"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["6", "5", "5", "5", "6", "5"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["6", "x", "7", "7", "8", "8"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "A#+9": [{
        "positions": ["x", "13", "12", "13", "13", "14"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["6", "x", "6", "7", "7", "8"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "A#Maj7#11": [{
        "positions": ["x", "1", "2", "2", "3", "1"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["6", "x", "7", "7", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "10", "10"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "A#9b5": [{
        "positions": ["x", "13", "12", "13", "13", "12"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["6", "5", "6", "5", "5", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "A#7b9": [{
        "positions": ["x", "13", "12", "13", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "7"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "13", "12", "13", "12", "13"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "8", "7", "9", "7"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "A#7#9": [{
        "positions": ["x", "13", "12", "13", "14", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["6", "8", "6", "7", "6", "9"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "8", "7", "9", "9"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "A#7b5#9": [{"positions": ["x", "13", "12", "13", "14", "12"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "A#7#11": [{"positions": ["6", "7", "6", "7", "6", "6"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "A#7b5": [{
        "positions": ["x", "1", "2", "1", "3", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["6", "x", "6", "7", "5", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "8", "9", "9", "10"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "1", "2", "1", "3", "4"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "A#m9b5": [{"positions": ["6", "7", "6", "6", "9", "8"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "A#+7b9": [{
        "positions": ["x", "13", "12", "13", "12", "14"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["6", "x", "6", "7", "7", "7"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "A#+7#9": [{
        "positions": ["x", "13", "12", "13", "14", "14"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["6", "x", "6", "7", "7", "9"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "B#": [{
        "positions": ["x", "3", "5", "5", "5", "3"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["8", "10", "10", "9", "8", "8"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["8", "7", "5", "5", "5", "8"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "10", "12", "13", "12"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "B#m": [{
        "positions": ["x", "3", "5", "5", "4", "3"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["8", "10", "10", "8", "8", "8"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "8", "8", "8"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "10", "12", "13", "11"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "B#5": [{
        "positions": ["8", "10", "10", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "3", "5", "5", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "5", "8", "8"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "10", "12", "13", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "B#sus2": [{
        "positions": ["x", "3", "5", "5", "3", "3"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "5", "7", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "10", "7", "8", "10"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "10", "12", "13", "10"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "B#sus4": [{
        "positions": ["x", "3", "5", "5", "6", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["8", "10", "10", "10", "8", "8"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "13", "13"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "10", "10", "8", "8"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "B#+": [{
        "positions": ["x", "3", "2", "1", "1", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "9", "8"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["8", "7", "6", "5", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["8", "11", "10", "9", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "3", "x", "5", "5", "4"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "B#°": [{
        "positions": ["x", "3", "4", "5", "4", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["8", "x", "10", "8", "7", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["8", "9", "10", "8", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "B#7": [{
        "positions": ["x", "3", "5", "3", "5", "3"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "8"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "11", "12"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "3", "2", "3", "1", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["8", "x", "8", "9", "8", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "B#7sus4": [{
        "positions": ["x", "3", "3", "3", "1", "1"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "5", "3", "6", "3"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["8", "10", "8", "10", "8", "8"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "10", "12", "11", "13"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "B#m7": [{
        "positions": ["x", "3", "5", "3", "4", "3"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["8", "10", "10", "8", "11", "8"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["8", "x", "8", "8", "8", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "3", "1", "3", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["8", "10", "8", "8", "8", "8"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "3", "1", "3", "1", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "10", "12", "11", "11"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "B#Maj7": [{
        "positions": ["x", "x", "10", "9", "8", "7"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "3", "5", "4", "5", "3"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["8", "x", "9", "9", "8", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "12", "12", "12"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {"positions": ["8", "10", "9", "9", "8", "8"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "B#m7b5": [{
        "positions": ["8", "x", "8", "8", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "3", "4", "3", "4", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "11", "11"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["8", "9", "10", "11", "11", "11"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "3", "x", "3", "4", "2"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["8", "9", "8", "8", "11", "8"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "B#°7": [{
        "positions": ["x", "3", "4", "2", "4", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["8", "x", "7", "8", "7", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "10", "11"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "B#+7": [{
        "positions": ["x", "3", "6", "3", "5", "4"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["8", "x", "8", "9", "9", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "10", "13", "11", "12"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "3", "x", "3", "5", "4"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "B#mMaj7": [{
        "positions": ["x", "3", "5", "4", "4", "3"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["8", "x", "9", "8", "8", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["8", "10", "9", "8", "8", "8"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "12", "11"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "10", "8", "8", "7"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "B#add9": [{
        "positions": ["x", "x", "10", "9", "8", "10"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "3", "5", "7", "5", "3"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["8", "x", "x", "9", "8", "10"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "B#madd9": [{"positions": ["x", "x", "10", "8", "8", "10"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "B#6": [{
        "positions": ["x", "3", "5", "5", "5", "5"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "10", "12", "10", "12"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["8", "x", "7", "9", "8", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "B#m6": [{
        "positions": ["x", "3", "1", "2", "1", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["8", "10", "10", "8", "10", "8"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "10", "12", "10", "11"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "3", "5", "2", "4", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "3", "1", "2", "1", "3"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["8", "x", "7", "8", "8", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "3", "x", "2", "4", "3"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "B#mb6": [{
        "positions": ["x", "3", "1", "1", "1", "3"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["8", "x", "6", "8", "8", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "B#9": [{
        "positions": ["8", "10", "8", "9", "8", "10"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "3", "2", "3", "3", "3"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["8", "x", "8", "7", "5", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "11", "10"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["8", "7", "8", "7", "8", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "B#11": [{
        "positions": ["x", "3", "2", "3", "1", "1"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "3", "3", "5", "3"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "10", "10", "11", "12"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "B#13": [{
        "positions": ["x", "3", "2", "3", "3", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["8", "x", "8", "7", "5", "5"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["8", "x", "8", "9", "10", "10"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["8", "10", "8", "9", "10", "8"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "B#9sus4": [{
        "positions": ["x", "3", "3", "3", "3", "3"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["8", "x", "8", "7", "6", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["8", "x", "8", "7", "6", "6"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "B#13sus4": [{
        "positions": ["x", "3", "3", "3", "3", "5"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["8", "x", "8", "10", "10", "10"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "B#m9": [{
        "positions": ["8", "10", "8", "8", "8", "10"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "3", "1", "3", "3", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "3", "1", "3", "3", "3"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "10", "8", "11", "10"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["8", "x", "8", "8", "8", "10"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "B#m11": [{
        "positions": ["x", "3", "1", "3", "1", "1"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "3", "3", "3", "4", "3"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["8", "x", "8", "8", "6", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "10", "11", "11"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "3", "x", "3", "4", "1"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "B#m13": [{
        "positions": ["x", "3", "x", "3", "4", "5"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["8", "10", "8", "8", "10", "8"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["8", "x", "8", "8", "10", "10"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "3", "5", "3", "4", "5"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "3", "1", "3", "3", "5"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "B#mMaj9": [{
        "positions": ["x", "3", "1", "4", "3", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["8", "10", "9", "8", "8", "10"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "B#Maj9": [{
        "positions": ["x", "3", "2", "4", "3", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "10", "9", "12", "10"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "15", "12", "12", "12", "12"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["8", "7", "9", "7", "8", "7"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["8", "x", "9", "7", "8", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "B#Maj13": [{
        "positions": ["x", "3", "x", "4", "5", "5"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["8", "7", "7", "7", "8", "7"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["8", "x", "9", "9", "10", "10"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "B#+9": [{
        "positions": ["x", "3", "2", "3", "3", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["8", "x", "8", "9", "9", "10"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "B#Maj7#11": [{
        "positions": ["x", "3", "4", "4", "5", "3"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["8", "x", "9", "9", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "12", "12"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "B#9b5": [{
        "positions": ["x", "3", "2", "3", "3", "2"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["8", "7", "8", "7", "7", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "B#7b9": [{
        "positions": ["x", "3", "2", "3", "2", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "9"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "3", "2", "3", "2", "3"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "10", "9", "11", "9"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "B#7#9": [{
        "positions": ["x", "3", "2", "3", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["8", "10", "8", "9", "8", "11"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "10", "9", "11", "11"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "B#7b5#9": [{"positions": ["x", "3", "2", "3", "4", "2"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "B#7#11": [{"positions": ["8", "9", "8", "9", "8", "8"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "B#7b5": [{
        "positions": ["x", "3", "4", "3", "5", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["8", "x", "8", "9", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "10", "11", "11", "12"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "3", "4", "3", "5", "6"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "B#m9b5": [{"positions": ["8", "9", "8", "8", "11", "10"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "B#+7b9": [{
        "positions": ["x", "3", "2", "3", "2", "4"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["8", "x", "8", "9", "9", "9"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "B#+7#9": [{
        "positions": ["x", "3", "2", "3", "4", "4"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["8", "x", "8", "9", "9", "11"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "C#": [{
        "positions": ["x", "4", "6", "6", "6", "4"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["9", "11", "11", "10", "9", "9"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "4", "3", "1", "2", "1"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "13", "12", "13"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "8", "6", "6", "6", "9"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "11", "13", "14", "13"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "C#m": [{
        "positions": ["x", "4", "6", "6", "5", "4"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["9", "11", "11", "9", "9", "9"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "11", "9", "9", "9"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "11", "13", "14", "12"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "C#5": [{
        "positions": ["x", "4", "6", "6", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["9", "11", "11", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "6", "9", "9"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "11", "13", "14", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "C#sus2": [{
        "positions": ["x", "4", "6", "6", "4", "4"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "1", "1", "2", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "6", "8", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "8", "9", "11"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "11", "13", "14", "11"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "C#sus4": [{
        "positions": ["x", "4", "6", "6", "7", "4"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["9", "11", "11", "11", "9", "9"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "4", "1", "2", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "13", "14", "14"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "11", "11", "9", "9"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "C#+": [{
        "positions": ["x", "4", "3", "2", "2", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "10", "9"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["9", "8", "7", "6", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["9", "12", "11", "10", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "4", "x", "6", "6", "5"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "C#°": [{
        "positions": ["x", "4", "5", "6", "5", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["9", "x", "11", "9", "8", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["9", "10", "11", "9", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "C#7": [{
        "positions": ["x", "4", "6", "4", "6", "4"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "9"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "10", "9", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "4", "3", "4", "2", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["x", "x", "11", "13", "12", "13"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "C#7sus4": [{
        "positions": ["x", "4", "4", "4", "2", "2"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["9", "11", "9", "11", "9", "9"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "6", "4", "7", "4"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "11", "13", "12", "14"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "C#m7": [{
        "positions": ["x", "4", "6", "4", "5", "4"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["9", "11", "11", "9", "12", "9"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["9", "x", "9", "9", "9", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "4", "2", "4", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["9", "11", "9", "9", "9", "9"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "4", "2", "4", "2", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "11", "13", "12", "12"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "C#Maj7": [{
        "positions": ["x", "4", "6", "5", "6", "4"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "11", "10", "9", "8"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "11", "13", "13", "13"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "4", "3", "1", "1", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "x", "10", "10", "9", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["9", "11", "10", "10", "9", "9"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "C#m7b5": [{
        "positions": ["x", "4", "5", "4", "5", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["9", "x", "9", "9", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["9", "10", "11", "12", "12", "12"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "x", "11", "12", "12", "12"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["x", "4", "x", "4", "5", "3"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["9", "10", "9", "9", "12", "9"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "C#°7": [{
        "positions": ["x", "4", "5", "3", "5", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["9", "10", "8", "9", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "x", "8", "9", "8", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "11", "12", "11", "12"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "C#+7": [{
        "positions": ["x", "4", "7", "4", "6", "5"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["9", "x", "9", "10", "10", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "11", "14", "12", "13"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "4", "x", "4", "6", "5"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "C#mMaj7": [{
        "positions": ["x", "4", "6", "5", "5", "4"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["9", "x", "10", "9", "9", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["9", "11", "10", "9", "9", "9"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "11", "13", "13", "12"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "11", "9", "9", "8"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "C#add9": [{
        "positions": ["x", "4", "6", "6", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "9", "11"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "4", "1", "1", "2", "1"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "6", "8", "6", "4"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["9", "x", "x", "10", "9", "11"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "C#madd9": [{"positions": ["x", "x", "11", "9", "9", "11"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "C#6": [{
        "positions": ["x", "4", "6", "6", "6", "6"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["0", "0", "11", "10", "11", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "11", "13", "11", "13"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["9", "x", "8", "10", "9", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "C#m6": [{
        "positions": ["x", "4", "2", "3", "2", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["9", "11", "11", "9", "11", "9"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "11", "13", "11", "12"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "4", "6", "3", "5", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "4", "2", "3", "2", "4"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["9", "x", "8", "9", "9", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "4", "x", "3", "5", "4"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "C#mb6": [{
        "positions": ["x", "4", "2", "2", "2", "4"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["9", "x", "7", "9", "9", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "C#9": [{
        "positions": ["x", "4", "3", "4", "4", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "11"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["9", "x", "9", "8", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "3", "4", "4", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["9", "x", "9", "8", "6", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "12", "11"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["9", "8", "9", "8", "9", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "C#11": [{
        "positions": ["x", "4", "4", "4", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["9", "x", "9", "8", "7", "7"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "4", "3", "4", "2", "2"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "4", "4", "6", "4"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "11", "11", "12", "13"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "C#13": [{
        "positions": ["x", "4", "3", "4", "4", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["9", "x", "9", "8", "6", "6"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "10", "11", "11"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["9", "11", "9", "10", "11", "9"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "C#9sus4": [{
        "positions": ["x", "4", "4", "4", "4", "4"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["9", "x", "9", "8", "7", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["9", "x", "9", "8", "7", "7"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "C#13sus4": [{
        "positions": ["x", "4", "4", "4", "4", "6"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["9", "x", "9", "11", "11", "11"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "C#m9": [{
        "positions": ["x", "4", "2", "4", "4", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["9", "11", "9", "9", "9", "11"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "4", "2", "4", "4", "4"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "11", "9", "12", "11"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["9", "x", "9", "9", "9", "11"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "C#m11": [{
        "positions": ["x", "4", "2", "4", "2", "2"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "4", "4", "4", "5", "4"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["9", "x", "9", "9", "7", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "11", "12", "12"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "4", "x", "4", "5", "2"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "C#m13": [{
        "positions": ["x", "4", "x", "4", "5", "6"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["9", "11", "9", "9", "11", "9"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["9", "x", "9", "9", "11", "11"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "4", "6", "4", "5", "6"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "4", "2", "4", "4", "6"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "C#mMaj9": [{
        "positions": ["x", "4", "2", "5", "4", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["9", "11", "10", "9", "9", "11"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "C#Maj9": [{
        "positions": ["x", "4", "3", "5", "4", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "11", "10", "13", "11"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "4", "1", "1", "1", "1"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["9", "8", "10", "8", "9", "8"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["9", "x", "10", "8", "9", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "C#Maj13": [{
        "positions": ["x", "4", "x", "5", "6", "6"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["9", "8", "8", "8", "9", "8"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["9", "x", "10", "10", "11", "11"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "C#+9": [{
        "positions": ["x", "4", "3", "4", "4", "5"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["9", "x", "9", "10", "10", "11"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "C#Maj7#11": [{
        "positions": ["x", "4", "5", "5", "6", "4"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["9", "x", "10", "10", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "12", "13", "13"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "C#9b5": [{
        "positions": ["x", "4", "3", "4", "4", "3"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["9", "8", "9", "8", "8", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "C#7b9": [{
        "positions": ["x", "4", "3", "4", "3", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "10"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "4", "3", "4", "3", "4"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "11", "10", "12", "10"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "C#7#9": [{
        "positions": ["x", "4", "3", "4", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["9", "11", "9", "10", "9", "12"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "11", "10", "12", "12"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "C#7b5#9": [{"positions": ["x", "4", "3", "4", "5", "3"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "C#7#11": [{"positions": ["9", "10", "9", "10", "9", "9"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "C#7b5": [{
        "positions": ["x", "4", "5", "4", "6", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["9", "x", "9", "10", "8", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "11", "12", "12", "13"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "4", "5", "4", "6", "7"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "C#m9b5": [{"positions": ["9", "10", "9", "9", "12", "11"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "C#+7b9": [{
        "positions": ["x", "4", "3", "4", "3", "5"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["9", "x", "9", "10", "10", "10"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "C#+7#9": [{
        "positions": ["x", "4", "3", "4", "5", "5"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["9", "x", "9", "10", "10", "12"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "D#": [{
        "positions": ["x", "6", "8", "8", "8", "6"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "6", "5", "3", "4", "3"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "1", "3", "4", "3"],
        "fingerings": [["0", "0", "1", "2", "4", "3"]]
    }, {
        "positions": ["11", "13", "13", "12", "11", "11"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {"positions": ["11", "10", "8", "8", "8", "11"], "fingerings": [["3", "2", "1", "1", "1", "4"]]}],
    "D#m": [{
        "positions": ["x", "6", "8", "8", "7", "6"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["x", "x", "1", "3", "4", "2"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["11", "13", "13", "11", "11", "11"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {"positions": ["x", "x", "13", "11", "11", "11"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "D#5": [{
        "positions": ["x", "6", "8", "8", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["11", "13", "13", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "8", "11", "11"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "1", "3", "4", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "D#sus2": [{
        "positions": ["x", "x", "1", "3", "4", "1"],
        "fingerings": [["0", "0", "1", "3", "4", "1"]]
    }, {
        "positions": ["x", "6", "8", "8", "6", "6"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "8", "10", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {"positions": ["x", "x", "13", "10", "11", "13"], "fingerings": [["0", "0", "3", "1", "2", "4"]]}],
    "D#sus4": [{
        "positions": ["x", "6", "8", "8", "9", "6"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "6", "6", "3", "4", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "8", "8", "9", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "13", "13", "13", "11", "11"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "1", "3", "4", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "13", "13", "11", "11"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "D#+": [{
        "positions": ["x", "6", "5", "4", "4", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "12", "11"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["11", "10", "9", "8", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["11", "14", "13", "12", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "6", "x", "8", "8", "7"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "D#°": [{
        "positions": ["x", "6", "7", "8", "7", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["11", "x", "13", "11", "10", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["11", "12", "13", "11", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "D#7": [{
        "positions": ["x", "x", "1", "3", "2", "3"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "6", "8", "6", "8", "6"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["11", "x", "11", "12", "11", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "6", "5", "6", "4", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["11", "13", "11", "12", "11", "11"], "fingerings": [["1", "3", "1", "2", "1", "1"]]}],
    "D#7sus4": [{
        "positions": ["x", "6", "6", "6", "4", "4"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "8", "6", "9", "6"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["11", "13", "11", "13", "11", "11"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "1", "3", "2", "4"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "D#m7": [{
        "positions": ["x", "x", "1", "3", "2", "2"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {
        "positions": ["x", "6", "8", "6", "7", "6"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["11", "x", "11", "11", "11", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["11", "13", "11", "11", "14", "11"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "4", "6", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["11", "13", "13", "11", "14", "11"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["11", "13", "11", "11", "11", "11"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {"positions": ["x", "6", "4", "6", "4", "x"], "fingerings": [["0", "3", "1", "4", "1", "0"]]}],
    "D#Maj7": [{
        "positions": ["x", "x", "1", "3", "3", "3"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "6", "8", "7", "8", "6"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "13", "15", "15", "15"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "5", "3", "3", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "11", "10"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["11", "x", "12", "12", "11", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["11", "13", "12", "12", "11", "11"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "D#m7b5": [{
        "positions": ["x", "6", "7", "6", "7", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "2", "2"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["11", "x", "11", "11", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["11", "12", "13", "14", "14", "14"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "6", "x", "6", "7", "5"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["11", "12", "11", "11", "14", "11"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "D#°7": [{
        "positions": ["x", "6", "7", "5", "7", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "1", "2"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["11", "x", "10", "11", "10", "x"], "fingerings": [["3", "0", "1", "4", "2", "0"]]}],
    "D#+7": [{
        "positions": ["x", "6", "9", "6", "8", "7"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["11", "x", "11", "12", "12", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "1", "4", "2", "3"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "6", "x", "6", "8", "7"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "D#mMaj7": [{
        "positions": ["x", "6", "8", "7", "7", "6"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["11", "x", "12", "11", "11", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["11", "13", "12", "11", "11", "11"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "1", "3", "3", "2"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "13", "11", "11", "10"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "D#add9": [{
        "positions": ["x", "6", "8", "8", "6", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "11", "13"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "6", "8", "10", "8", "6"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["11", "x", "x", "12", "11", "13"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "D#madd9": [{"positions": ["x", "x", "13", "11", "11", "13"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "D#6": [{
        "positions": ["x", "x", "1", "3", "1", "3"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "6", "8", "8", "8", "8"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "13", "15", "13", "15"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {"positions": ["11", "x", "10", "12", "11", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "D#m6": [{
        "positions": ["x", "x", "1", "3", "1", "2"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "6", "4", "5", "4", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["x", "x", "13", "15", "13", "14"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "8", "5", "7", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["11", "13", "13", "11", "13", "11"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "6", "4", "5", "4", "6"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["11", "x", "10", "11", "11", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "6", "x", "5", "7", "6"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "D#mb6": [{
        "positions": ["x", "6", "4", "4", "4", "6"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["11", "x", "9", "11", "11", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "D#9": [{
        "positions": ["x", "6", "5", "6", "6", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "13", "11", "12", "11", "13"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "6", "5", "6", "6", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["11", "x", "11", "10", "8", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "14", "13"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["11", "10", "11", "10", "11", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "D#11": [{
        "positions": ["x", "6", "6", "6", "6", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["11", "x", "11", "10", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "6", "5", "6", "4", "4"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "6", "6", "8", "6"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "1", "1", "2", "3"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "D#13": [{
        "positions": ["x", "6", "5", "6", "6", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["11", "x", "11", "10", "8", "8"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["11", "x", "11", "12", "13", "13"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["11", "13", "11", "12", "13", "11"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "D#9sus4": [{
        "positions": ["x", "6", "6", "6", "6", "6"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["11", "x", "11", "10", "9", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["11", "x", "11", "10", "9", "9"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "D#13sus4": [{
        "positions": ["x", "6", "6", "6", "6", "8"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["11", "x", "11", "13", "13", "13"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "D#m9": [{
        "positions": ["x", "6", "4", "6", "6", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["11", "13", "11", "11", "11", "13"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "6", "4", "6", "6", "6"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "13", "11", "14", "13"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["11", "x", "11", "11", "11", "13"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "D#m11": [{
        "positions": ["x", "6", "4", "6", "4", "4"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "6", "6", "6", "7", "6"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["11", "x", "11", "11", "9", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "1", "1", "2", "2"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "6", "x", "6", "7", "4"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "D#m13": [{
        "positions": ["x", "6", "x", "6", "7", "8"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["11", "13", "11", "11", "13", "11"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["11", "x", "11", "11", "13", "13"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "6", "8", "6", "7", "8"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "6", "4", "6", "6", "8"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "D#mMaj9": [{
        "positions": ["x", "6", "4", "7", "6", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["11", "13", "12", "11", "11", "13"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "D#Maj9": [{
        "positions": ["x", "6", "5", "7", "6", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "13", "12", "15", "13"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "6", "3", "3", "3", "3"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["11", "10", "12", "10", "11", "10"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["11", "x", "12", "10", "11", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "D#Maj13": [{
        "positions": ["x", "6", "x", "7", "8", "8"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["11", "10", "10", "10", "11", "10"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["11", "x", "12", "12", "13", "13"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "D#+9": [{
        "positions": ["x", "6", "5", "6", "6", "7"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["11", "x", "11", "12", "12", "13"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "D#Maj7#11": [{
        "positions": ["x", "6", "7", "7", "8", "6"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["11", "x", "12", "12", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "3", "3"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "D#9b5": [{
        "positions": ["x", "6", "5", "6", "6", "5"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["11", "10", "11", "10", "10", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "D#7b9": [{
        "positions": ["x", "6", "5", "6", "5", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["11", "13", "11", "12", "11", "12"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "6", "5", "6", "5", "6"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "13", "12", "14", "12"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "D#7#9": [{
        "positions": ["x", "6", "5", "6", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["11", "13", "11", "12", "11", "14"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "13", "12", "14", "14"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "D#7b5#9": [{"positions": ["x", "6", "5", "6", "7", "5"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "D#7#11": [{"positions": ["11", "12", "11", "12", "11", "11"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "D#7b5": [{
        "positions": ["x", "6", "7", "6", "8", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["11", "x", "11", "12", "10", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "1", "2", "2", "3"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "6", "7", "6", "8", "9"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "D#m9b5": [{"positions": ["11", "12", "11", "11", "14", "13"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "D#+7b9": [{
        "positions": ["x", "6", "5", "6", "5", "7"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["11", "x", "11", "12", "12", "12"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "D#+7#9": [{
        "positions": ["x", "6", "5", "6", "7", "7"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["11", "x", "11", "12", "12", "14"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "E#": [{
        "positions": ["x", "8", "10", "10", "10", "8"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["1", "3", "3", "2", "1", "1"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["13", "12", "10", "10", "10", "13"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "3", "5", "6", "5"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "E#m": [{
        "positions": ["x", "8", "10", "10", "9", "8"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["1", "3", "3", "1", "1", "1"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "3", "1", "1", "1"],
        "fingerings": [["0", "0", "3", "1", "1", "1"]]
    }, {"positions": ["x", "x", "3", "5", "6", "4"], "fingerings": [["0", "0", "1", "3", "4", "2"]]}],
    "E#5": [{
        "positions": ["1", "3", "3", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "8", "10", "10", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "10", "13", "13"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "3", "5", "6", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "E#sus2": [{
        "positions": ["x", "8", "10", "10", "8", "8"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "12", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {
        "positions": ["x", "x", "15", "12", "13", "15"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {"positions": ["x", "x", "3", "5", "6", "3"], "fingerings": [["0", "0", "1", "3", "4", "1"]]}],
    "E#sus4": [{
        "positions": ["x", "8", "10", "10", "11", "8"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["1", "3", "3", "3", "1", "1"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "6", "6"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "3", "3", "1", "1"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "E#+": [{
        "positions": ["x", "8", "7", "6", "6", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "3", "2", "2", "1"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["13", "12", "11", "10", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["1", "4", "3", "2", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "8", "x", "10", "10", "9"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "E#°": [{
        "positions": ["x", "8", "9", "10", "9", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["13", "x", "15", "13", "12", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["1", "2", "3", "1", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "E#7": [{
        "positions": ["x", "8", "10", "8", "10", "8"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["1", "3", "1", "2", "1", "1"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "4", "5"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "8", "7", "8", "6", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["1", "x", "1", "2", "1", "x"], "fingerings": [["1", "0", "2", "4", "3", "0"]]}],
    "E#7sus4": [{
        "positions": ["x", "8", "8", "8", "6", "6"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "10", "8", "11", "8"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["1", "3", "1", "3", "1", "1"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {"positions": ["x", "x", "3", "5", "4", "6"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "E#m7": [{
        "positions": ["x", "8", "10", "8", "9", "8"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["1", "3", "3", "1", "4", "1"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["1", "x", "1", "1", "1", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "8", "6", "8", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["1", "3", "1", "1", "1", "1"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["x", "8", "6", "8", "6", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "3", "5", "4", "4"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "E#Maj7": [{
        "positions": ["x", "x", "15", "14", "13", "12"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "8", "10", "9", "10", "8"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["1", "x", "2", "2", "1", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "3", "5", "5", "5"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {"positions": ["1", "3", "2", "2", "1", "1"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "E#m7b5": [{
        "positions": ["13", "x", "13", "13", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "8", "9", "8", "9", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "4", "4"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["1", "2", "3", "4", "4", "4"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "8", "x", "8", "9", "7"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["1", "2", "1", "1", "4", "1"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "E#°7": [{
        "positions": ["x", "8", "9", "7", "9", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["13", "x", "12", "13", "12", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "3", "4"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "E#+7": [{
        "positions": ["x", "8", "11", "8", "10", "9"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["1", "x", "1", "2", "2", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "3", "6", "4", "5"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "8", "x", "8", "10", "9"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "E#mMaj7": [{
        "positions": ["x", "8", "10", "9", "9", "8"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["1", "x", "2", "1", "1", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["1", "3", "2", "1", "1", "1"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "5", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "15", "13", "13", "12"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "E#add9": [{
        "positions": ["x", "x", "3", "2", "1", "3"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "8", "10", "12", "10", "8"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["1", "x", "x", "2", "1", "3"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "E#madd9": [{"positions": ["x", "x", "3", "1", "1", "3"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "E#6": [{
        "positions": ["x", "8", "10", "10", "10", "10"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "3", "5", "3", "5"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["13", "x", "12", "14", "13", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "E#m6": [{
        "positions": ["x", "8", "6", "7", "6", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["1", "3", "3", "1", "3", "1"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "3", "5", "3", "4"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "8", "10", "7", "9", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "8", "6", "7", "6", "8"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["13", "x", "12", "13", "13", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {"positions": ["x", "8", "x", "7", "9", "8"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "E#mb6": [{
        "positions": ["x", "8", "6", "6", "6", "8"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["13", "x", "11", "13", "13", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "E#9": [{
        "positions": ["1", "3", "1", "2", "1", "3"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "8", "7", "8", "8", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["13", "x", "13", "12", "10", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "2", "4", "3"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["13", "12", "13", "12", "13", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "E#11": [{
        "positions": ["x", "8", "7", "8", "6", "6"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "8", "8", "10", "8"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "3", "3", "4", "5"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "E#13": [{
        "positions": ["x", "8", "7", "8", "8", "10"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["13", "x", "13", "12", "10", "10"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["1", "x", "1", "2", "3", "3"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {"positions": ["1", "3", "1", "2", "3", "1"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "E#9sus4": [{
        "positions": ["x", "8", "8", "8", "8", "8"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["13", "x", "13", "12", "11", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["13", "x", "13", "12", "11", "11"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "E#13sus4": [{
        "positions": ["x", "8", "8", "8", "8", "10"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["1", "x", "1", "3", "3", "3"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "E#m9": [{
        "positions": ["1", "3", "1", "1", "1", "3"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "8", "6", "8", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "8", "6", "8", "8", "8"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "3", "1", "4", "3"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["1", "x", "1", "1", "1", "3"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "E#m11": [{
        "positions": ["x", "8", "6", "8", "6", "6"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "8", "8", "8", "9", "8"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["13", "x", "13", "13", "11", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "3", "4", "4"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "8", "x", "8", "9", "6"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "E#m13": [{
        "positions": ["x", "8", "x", "8", "9", "10"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["1", "3", "1", "1", "3", "1"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["1", "x", "1", "1", "3", "3"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "8", "10", "8", "9", "10"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "8", "6", "8", "8", "10"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "E#mMaj9": [{
        "positions": ["x", "8", "6", "9", "8", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["1", "3", "2", "1", "1", "3"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "E#Maj9": [{
        "positions": ["x", "8", "7", "9", "8", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "3", "2", "5", "3"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "8", "5", "5", "5", "5"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["13", "12", "14", "12", "13", "12"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["13", "x", "14", "12", "13", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "E#Maj13": [{
        "positions": ["x", "8", "x", "9", "10", "10"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["13", "12", "12", "12", "13", "12"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["1", "x", "2", "2", "3", "3"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "E#+9": [{
        "positions": ["x", "8", "7", "8", "8", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["1", "x", "1", "2", "2", "3"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "E#Maj7#11": [{
        "positions": ["x", "8", "9", "9", "10", "8"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["13", "x", "14", "14", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "5", "5"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "E#9b5": [{
        "positions": ["x", "8", "7", "8", "8", "7"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["13", "12", "13", "12", "12", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "E#7b9": [{
        "positions": ["x", "8", "7", "8", "7", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["1", "3", "1", "2", "1", "2"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "8", "7", "8", "7", "8"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "3", "2", "4", "2"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "E#7#9": [{
        "positions": ["x", "8", "7", "8", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["1", "3", "1", "2", "1", "4"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "3", "2", "4", "4"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "E#7b5#9": [{"positions": ["x", "8", "7", "8", "9", "7"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "E#7#11": [{"positions": ["1", "2", "1", "2", "1", "1"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "E#7b5": [{
        "positions": ["x", "8", "9", "8", "10", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["13", "x", "13", "14", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "3", "4", "4", "5"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "8", "9", "8", "10", "11"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "E#m9b5": [{"positions": ["1", "2", "1", "1", "4", "3"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "E#+7b9": [{
        "positions": ["x", "8", "7", "8", "7", "9"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["1", "x", "1", "2", "2", "2"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "E#+7#9": [{
        "positions": ["x", "8", "7", "8", "9", "9"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["1", "x", "1", "2", "2", "4"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "F#": [{
        "positions": ["2", "4", "4", "3", "2", "2"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "11", "11", "9"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "9", "8", "6", "7", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "2", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["14", "13", "11", "11", "11", "14"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "4", "6", "7", "6"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "F#m": [{
        "positions": ["2", "4", "4", "2", "2", "2"],
        "fingerings": [["1", "3", "4", "1", "1", "1"], ["1", "2", "3", "1", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "11", "10", "9"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "7", "5"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "4", "2", "2", "2"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "F#5": [{
        "positions": ["2", "4", "4", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "11", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "11", "14", "14"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "4", "6", "7", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "F#sus2": [{
        "positions": ["2", "4", "4", "1", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "4", "1", "2", "4"],
        "fingerings": [["0", "0", "3", "1", "2", "4"]]
    }, {
        "positions": ["2", "x", "2", "1", "2", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "11", "9", "9"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "7", "4"],
        "fingerings": [["0", "0", "1", "3", "4", "1"]]
    }, {"positions": ["x", "9", "11", "13", "x", "x"], "fingerings": [["0", "1", "3", "4", "0", "0"]]}],
    "F#sus4": [{
        "positions": ["2", "4", "4", "4", "2", "2"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "11", "12", "9"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["x", "9", "9", "6", "7", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "4", "6", "7", "7"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {"positions": ["x", "x", "4", "4", "2", "2"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "F#+": [{
        "positions": ["x", "9", "8", "7", "7", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "3", "2"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["14", "13", "12", "11", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["2", "5", "4", "3", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "9", "x", "11", "11", "10"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "F#°": [{
        "positions": ["x", "9", "10", "11", "10", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["2", "x", "4", "2", "1", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["2", "3", "4", "2", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "F#7": [{
        "positions": ["2", "4", "2", "3", "2", "2"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["x", "9", "10", "9", "10", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["2", "x", "2", "3", "2", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "4", "6", "5", "6"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {
        "positions": ["x", "9", "8", "9", "7", "x"],
        "fingerings": [["0", "3", "2", "4", "1", "0"]]
    }, {"positions": ["x", "9", "11", "9", "11", "9"], "fingerings": [["0", "1", "3", "1", "4", "1"]]}],
    "F#7sus4": [{
        "positions": ["2", "4", "2", "4", "2", "2"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "9", "9", "7", "7"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "11", "9", "12", "9"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "4", "6", "5", "7"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "F#m7": [{
        "positions": ["2", "4", "2", "2", "2", "2"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["2", "x", "2", "2", "2", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "9", "11", "9", "10", "9"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["x", "9", "7", "9", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["2", "4", "4", "2", "5", "2"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "9", "7", "9", "7", "x"],
        "fingerings": [["0", "3", "1", "4", "1", "0"]]
    }, {"positions": ["x", "x", "4", "6", "5", "5"], "fingerings": [["0", "0", "1", "4", "2", "3"]]}],
    "F#Maj7": [{
        "positions": ["x", "x", "4", "3", "2", "1"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "9", "11", "10", "11", "9"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "6", "6"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "9", "8", "6", "6", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["2", "x", "3", "3", "2", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {"positions": ["2", "4", "3", "3", "2", "2"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "F#m7b5": [{
        "positions": ["2", "x", "2", "2", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "9", "10", "9", "10", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "5", "5"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["2", "3", "4", "5", "5", "5"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "9", "x", "9", "10", "8"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["2", "3", "2", "2", "5", "2"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "F#°7": [{
        "positions": ["2", "3", "1", "2", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "10", "8", "10", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "4", "5"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["2", "x", "1", "2", "1", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {"positions": ["2", "3", "4", "2", "4", "2"], "fingerings": [["0", "0", "0", "0", "0", "0"]]}],
    "F#+7": [{
        "positions": ["x", "9", "12", "9", "11", "10"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["2", "x", "2", "3", "3", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "4", "7", "5", "6"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "9", "x", "9", "11", "10"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "F#mMaj7": [{
        "positions": ["x", "9", "11", "10", "10", "9"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["2", "x", "3", "2", "2", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["2", "4", "3", "2", "2", "2"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "6", "5"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "4", "2", "2", "1"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "F#add9": [{
        "positions": ["x", "x", "4", "3", "2", "4"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "9", "11", "11", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "13", "11", "9"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["2", "x", "x", "3", "2", "4"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "F#madd9": [{"positions": ["x", "x", "4", "2", "2", "4"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "F#6": [{
        "positions": ["x", "x", "4", "3", "4", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "11", "11", "11", "11"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "x", "4", "6", "4", "6"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {"positions": ["2", "x", "1", "3", "2", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "F#m6": [{
        "positions": ["2", "4", "4", "2", "4", "2"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "4", "6", "4", "5"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "9", "7", "8", "7", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["2", "x", "1", "2", "2", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "9", "11", "8", "10", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "9", "7", "8", "7", "9"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "9", "x", "8", "10", "9"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "F#mb6": [{
        "positions": ["x", "9", "7", "7", "7", "9"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["14", "x", "12", "14", "14", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "F#9": [{
        "positions": ["2", "4", "2", "3", "2", "4"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["x", "9", "8", "9", "9", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "8", "9", "9", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["14", "x", "14", "13", "11", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "5", "4"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["2", "1", "2", "1", "2", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "F#11": [{
        "positions": ["2", "4", "2", "4", "2", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "9", "9", "9", "9"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["2", "x", "2", "1", "0", "0"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "9", "8", "9", "7", "7"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "9", "9", "11", "9"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "4", "4", "5", "6"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "F#13": [{
        "positions": ["2", "x", "2", "3", "4", "4"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {
        "positions": ["x", "9", "8", "9", "9", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {
        "positions": ["14", "x", "14", "13", "11", "11"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {"positions": ["2", "4", "2", "3", "4", "2"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "F#9sus4": [{
        "positions": ["x", "9", "9", "9", "9", "9"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["14", "x", "14", "13", "12", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["14", "x", "14", "13", "12", "12"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "F#13sus4": [{
        "positions": ["x", "9", "9", "9", "9", "11"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["2", "x", "2", "4", "4", "4"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "F#m9": [{
        "positions": ["2", "4", "2", "2", "2", "4"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "9", "7", "9", "9", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "9", "7", "9", "9", "9"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "4", "2", "5", "4"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["2", "x", "2", "2", "2", "4"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "F#m11": [{
        "positions": ["x", "9", "7", "9", "7", "7"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "9", "9", "9", "10", "9"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["14", "x", "14", "14", "12", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "4", "5", "5"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "9", "x", "9", "10", "7"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "F#m13": [{
        "positions": ["x", "9", "x", "9", "10", "11"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["2", "4", "2", "2", "4", "2"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["2", "x", "2", "2", "4", "4"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "9", "11", "9", "10", "11"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "9", "7", "9", "9", "11"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "F#mMaj9": [{
        "positions": ["x", "9", "7", "10", "9", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["2", "4", "3", "2", "2", "4"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "F#Maj9": [{
        "positions": ["x", "9", "8", "10", "9", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "4", "3", "6", "4"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "9", "6", "6", "6", "6"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["2", "1", "3", "1", "2", "1"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["2", "x", "3", "1", "2", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "F#Maj13": [{
        "positions": ["x", "9", "x", "10", "11", "11"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["2", "1", "1", "1", "2", "1"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["2", "x", "3", "3", "4", "4"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "F#+9": [{
        "positions": ["x", "9", "8", "9", "9", "10"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["2", "x", "2", "3", "3", "4"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "F#Maj7#11": [{
        "positions": ["x", "9", "10", "10", "11", "9"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["2", "x", "3", "3", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "6", "6"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "F#9b5": [{
        "positions": ["x", "9", "8", "9", "9", "8"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["2", "1", "2", "1", "1", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "F#7b9": [{
        "positions": ["x", "9", "8", "9", "8", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["2", "4", "2", "3", "2", "3"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "9", "8", "9", "8", "9"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "4", "3", "5", "3"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "F#7#9": [{
        "positions": ["x", "9", "8", "9", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["2", "4", "2", "3", "2", "5"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "4", "3", "5", "5"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "F#7b5#9": [{"positions": ["x", "9", "8", "9", "10", "8"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "F#7#11": [{"positions": ["2", "3", "2", "3", "2", "2"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "F#7b5": [{
        "positions": ["x", "9", "10", "9", "11", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["2", "x", "2", "3", "1", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "4", "5", "5", "6"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "9", "10", "9", "11", "12"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "F#m9b5": [{"positions": ["2", "3", "2", "2", "5", "4"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "F#+7b9": [{
        "positions": ["x", "9", "8", "9", "8", "10"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["2", "x", "2", "3", "3", "3"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "F#+7#9": [{
        "positions": ["x", "9", "8", "9", "10", "10"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["2", "x", "2", "3", "3", "5"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "G#": [{
        "positions": ["4", "6", "6", "5", "4", "4"],
        "fingerings": [["1", "3", "4", "2", "1", "1"]]
    }, {
        "positions": ["x", "11", "10", "9", "8", "8"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "13", "13", "11"],
        "fingerings": [["0", "1", "3", "3", "3", "1"], ["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["4", "3", "1", "1", "1", "4"],
        "fingerings": [["3", "2", "1", "1", "1", "4"]]
    }, {"positions": ["x", "x", "6", "8", "9", "8"], "fingerings": [["0", "0", "1", "2", "4", "3"]]}],
    "G#m": [{
        "positions": ["4", "6", "6", "4", "4", "4"],
        "fingerings": [["1", "3", "4", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "9", "7"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {
        "positions": ["x", "11", "13", "13", "12", "11"],
        "fingerings": [["0", "1", "3", "4", "2", "1"]]
    }, {"positions": ["x", "x", "6", "4", "4", "4"], "fingerings": [["0", "0", "3", "1", "1", "1"]]}],
    "G#5": [{
        "positions": ["4", "6", "6", "x", "x", "x"],
        "fingerings": [["1", "3", "4", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "13", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"], ["0", "1", "2", "3", "0", "0"], ["0", "1", "4", "4", "0", "0"], ["0", "1", "3", "3", "0", "0"]]
    }, {
        "positions": ["x", "x", "x", "1", "4", "4"],
        "fingerings": [["0", "0", "0", "1", "4", "4"]]
    }, {"positions": ["x", "x", "6", "8", "9", "x"], "fingerings": [["0", "0", "1", "3", "4", "0"]]}],
    "G#sus2": [{
        "positions": ["4", "1", "1", "1", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "13", "11", "11"],
        "fingerings": [["0", "1", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "9", "6"],
        "fingerings": [["0", "0", "1", "3", "4", "1"]]
    }, {
        "positions": ["x", "11", "13", "15", "x", "x"],
        "fingerings": [["0", "1", "3", "4", "0", "0"]]
    }, {"positions": ["x", "x", "6", "3", "4", "6"], "fingerings": [["0", "0", "3", "1", "2", "4"]]}],
    "G#sus4": [{
        "positions": ["4", "6", "6", "6", "4", "4"],
        "fingerings": [["1", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "8", "9", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "6", "8", "9", "9"],
        "fingerings": [["0", "0", "1", "3", "4", "4"]]
    }, {
        "positions": ["x", "11", "13", "13", "14", "11"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {"positions": ["x", "x", "6", "6", "4", "4"], "fingerings": [["0", "0", "3", "4", "1", "1"]]}],
    "G#+": [{
        "positions": ["x", "11", "10", "9", "9", "x"],
        "fingerings": [["0", "4", "3", "1", "2", "0"]]
    }, {
        "positions": ["x", "x", "6", "5", "5", "4"],
        "fingerings": [["0", "0", "4", "2", "3", "1"]]
    }, {
        "positions": ["4", "3", "2", "1", "x", "x"],
        "fingerings": [["4", "3", "2", "1", "0", "0"]]
    }, {
        "positions": ["4", "7", "6", "5", "x", "x"],
        "fingerings": [["1", "4", "3", "2", "0", "0"]]
    }, {"positions": ["x", "11", "x", "13", "13", "12"], "fingerings": [["0", "1", "0", "3", "4", "2"]]}],
    "G#°": [{
        "positions": ["x", "11", "12", "13", "12", "x"],
        "fingerings": [["0", "1", "2", "4", "3", "0"]]
    }, {
        "positions": ["4", "x", "6", "4", "3", "x"],
        "fingerings": [["2", "0", "4", "3", "1", "0"]]
    }, {"positions": ["4", "5", "6", "4", "x", "x"], "fingerings": [["1", "3", "4", "2", "0", "0"]]}],
    "G#7": [{
        "positions": ["4", "6", "4", "5", "4", "4"],
        "fingerings": [["1", "3", "1", "2", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "5", "4", "x"],
        "fingerings": [["1", "0", "2", "4", "3", "0"]]
    }, {
        "positions": ["x", "11", "13", "11", "13", "11"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "7", "8"],
        "fingerings": [["0", "0", "1", "3", "2", "4"]]
    }, {"positions": ["x", "11", "10", "11", "9", "x"], "fingerings": [["0", "3", "2", "4", "1", "0"]]}],
    "G#7sus4": [{
        "positions": ["4", "6", "4", "6", "4", "4"],
        "fingerings": [["1", "2", "1", "3", "1", "1"], ["1", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "9", "9"],
        "fingerings": [["0", "2", "3", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "13", "11", "14", "11"],
        "fingerings": [["0", "1", "3", "1", "4", "1"]]
    }, {"positions": ["x", "x", "6", "8", "7", "9"], "fingerings": [["0", "0", "1", "3", "2", "4"]]}],
    "G#m7": [{
        "positions": ["4", "6", "4", "4", "4", "4"],
        "fingerings": [["1", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "4", "4", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"], ["1", "0", "3", "3", "3", "0"], ["2", "0", "3", "3", "3", "0"]]
    }, {
        "positions": ["x", "11", "13", "11", "12", "11"],
        "fingerings": [["0", "1", "3", "1", "2", "1"], ["0", "1", "4", "1", "2", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "7", "7"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {
        "positions": ["4", "6", "6", "4", "7", "4"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "11", "9", "11", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {"positions": ["x", "11", "9", "11", "9", "x"], "fingerings": [["0", "3", "1", "4", "1", "0"]]}],
    "G#Maj7": [{
        "positions": ["x", "x", "6", "5", "4", "3"],
        "fingerings": [["0", "0", "4", "3", "2", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "8", "8"],
        "fingerings": [["0", "0", "1", "3", "3", "3"]]
    }, {
        "positions": ["4", "x", "5", "5", "4", "x"],
        "fingerings": [["1", "0", "3", "4", "2", "0"]]
    }, {
        "positions": ["x", "11", "10", "8", "8", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "12", "13", "11"],
        "fingerings": [["0", "1", "3", "2", "4", "1"]]
    }, {"positions": ["4", "6", "5", "5", "4", "4"], "fingerings": [["1", "4", "2", "3", "1", "1"]]}],
    "G#m7b5": [{
        "positions": ["x", "x", "6", "7", "7", "7"],
        "fingerings": [["0", "0", "1", "2", "3", "4"]]
    }, {
        "positions": ["4", "x", "4", "4", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["4", "5", "6", "7", "7", "7"],
        "fingerings": [["1", "2", "3", "4", "4", "4"]]
    }, {
        "positions": ["x", "11", "12", "11", "12", "x"],
        "fingerings": [["0", "1", "3", "2", "4", "0"]]
    }, {
        "positions": ["x", "11", "x", "11", "12", "10"],
        "fingerings": [["0", "2", "0", "3", "4", "1"]]
    }, {"positions": ["4", "5", "4", "4", "7", "4"], "fingerings": [["1", "2", "1", "1", "4", "1"]]}],
    "G#°7": [{
        "positions": ["4", "5", "3", "4", "x", "x"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "12", "10", "12", "x"],
        "fingerings": [["0", "2", "3", "1", "4", "0"]]
    }, {
        "positions": ["4", "x", "3", "4", "3", "x"],
        "fingerings": [["3", "0", "1", "4", "2", "0"]]
    }, {
        "positions": ["x", "x", "6", "7", "6", "7"],
        "fingerings": [["0", "0", "1", "3", "2", "4"], ["0", "0", "1", "2", "1", "3"]]
    }],
    "G#+7": [{
        "positions": ["x", "11", "14", "11", "13", "12"],
        "fingerings": [["0", "1", "4", "1", "3", "2"]]
    }, {
        "positions": ["4", "x", "4", "5", "5", "x"],
        "fingerings": [["1", "0", "2", "3", "4", "0"]]
    }, {
        "positions": ["x", "x", "6", "9", "7", "8"],
        "fingerings": [["0", "0", "1", "4", "2", "3"]]
    }, {"positions": ["x", "11", "x", "11", "13", "12"], "fingerings": [["0", "1", "0", "2", "4", "3"]]}],
    "G#mMaj7": [{
        "positions": ["x", "11", "13", "12", "12", "11"],
        "fingerings": [["0", "1", "4", "2", "3", "1"]]
    }, {
        "positions": ["4", "x", "5", "4", "4", "x"],
        "fingerings": [["1", "0", "4", "2", "3", "0"]]
    }, {
        "positions": ["4", "6", "5", "4", "4", "4"],
        "fingerings": [["1", "3", "2", "1", "1", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "8", "7"],
        "fingerings": [["0", "0", "1", "3", "4", "2"]]
    }, {"positions": ["x", "x", "6", "4", "4", "3"], "fingerings": [["0", "0", "4", "2", "3", "1"]]}],
    "G#add9": [{
        "positions": ["x", "x", "6", "5", "4", "6"],
        "fingerings": [["0", "0", "3", "2", "1", "4"]]
    }, {
        "positions": ["x", "11", "8", "8", "9", "8"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "14", "13", "11"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "13", "15", "13", "11"],
        "fingerings": [["0", "1", "2", "4", "3", "1"]]
    }, {"positions": ["4", "x", "x", "5", "4", "6"], "fingerings": [["1", "0", "0", "3", "2", "4"]]}],
    "G#madd9": [{"positions": ["x", "x", "6", "4", "4", "6"], "fingerings": [["0", "0", "3", "1", "1", "4"]]}],
    "G#6": [{
        "positions": ["x", "x", "6", "5", "6", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "x", "6", "8", "6", "8"],
        "fingerings": [["0", "0", "1", "3", "1", "4"], ["0", "0", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "11", "13", "13", "13", "13"],
        "fingerings": [["0", "1", "2", "3", "4", "4"]]
    }, {"positions": ["4", "x", "3", "5", "4", "x"], "fingerings": [["2", "0", "1", "4", "3", "0"]]}],
    "G#m6": [{
        "positions": ["4", "6", "6", "4", "6", "4"],
        "fingerings": [["1", "2", "3", "1", "4", "1"]]
    }, {
        "positions": ["x", "x", "6", "8", "6", "7"],
        "fingerings": [["0", "0", "1", "3", "1", "2"], ["0", "0", "1", "4", "1", "2"]]
    }, {
        "positions": ["x", "11", "9", "10", "9", "x"],
        "fingerings": [["0", "4", "1", "3", "2", "0"]]
    }, {
        "positions": ["4", "x", "3", "4", "4", "x"],
        "fingerings": [["2", "0", "1", "3", "4", "0"]]
    }, {
        "positions": ["x", "11", "13", "10", "12", "x"],
        "fingerings": [["0", "2", "4", "1", "3", "0"]]
    }, {
        "positions": ["x", "11", "9", "10", "9", "11"],
        "fingerings": [["0", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "11", "x", "10", "12", "11"], "fingerings": [["0", "2", "0", "1", "4", "3"]]}],
    "G#mb6": [{
        "positions": ["x", "11", "9", "9", "9", "11"],
        "fingerings": [["0", "3", "1", "1", "1", "4"]]
    }, {"positions": ["4", "x", "2", "4", "4", "x"], "fingerings": [["2", "0", "1", "3", "4", "0"]]}],
    "G#9": [{
        "positions": ["4", "6", "4", "5", "4", "6"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {
        "positions": ["4", "x", "4", "3", "4", "4"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "x", "10", "11", "11"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "10", "11", "11", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["4", "x", "4", "3", "1", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "5", "7", "6"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["4", "3", "4", "3", "4", "x"], "fingerings": [["2", "1", "3", "1", "4", "0"]]}],
    "G#11": [{
        "positions": ["4", "6", "4", "6", "4", "6"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["4", "x", "4", "3", "2", "2"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "11", "11", "11", "11"],
        "fingerings": [["0", "0", "0", "0", "0", "0"]]
    }, {
        "positions": ["x", "11", "10", "11", "9", "9"],
        "fingerings": [["0", "3", "2", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "13", "11"],
        "fingerings": [["0", "1", "1", "1", "3", "1"]]
    }, {"positions": ["x", "x", "6", "6", "7", "8"], "fingerings": [["0", "0", "1", "1", "2", "3"]]}],
    "G#13": [{
        "positions": ["4", "x", "4", "3", "1", "1"],
        "fingerings": [["3", "0", "4", "2", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "5", "6", "6"],
        "fingerings": [["1", "0", "1", "1", "2", "3"]]
    }, {
        "positions": ["x", "11", "10", "11", "11", "13"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["4", "6", "4", "5", "6", "4"], "fingerings": [["1", "3", "1", "2", "4", "1"]]}],
    "G#9sus4": [{
        "positions": ["x", "11", "11", "11", "11", "11"],
        "fingerings": [["0", "1", "1", "1", "1", "1"]]
    }, {
        "positions": ["4", "x", "4", "3", "2", "x"],
        "fingerings": [["3", "0", "4", "2", "1", "0"]]
    }, {"positions": ["4", "x", "4", "3", "2", "2"], "fingerings": [["3", "0", "4", "2", "1", "1"]]}],
    "G#13sus4": [{
        "positions": ["x", "11", "11", "11", "11", "13"],
        "fingerings": [["0", "1", "1", "1", "1", "3"]]
    }, {"positions": ["4", "x", "4", "6", "6", "6"], "fingerings": [["1", "0", "2", "4", "4", "4"]]}],
    "G#m9": [{
        "positions": ["4", "6", "4", "4", "4", "6"],
        "fingerings": [["1", "2", "1", "1", "1", "3"], ["1", "3", "1", "1", "1", "4"]]
    }, {
        "positions": ["x", "11", "9", "11", "11", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"], ["0", "2", "1", "3", "3", "0"]]
    }, {
        "positions": ["x", "11", "9", "11", "11", "11"],
        "fingerings": [["0", "2", "1", "3", "3", "3"]]
    }, {
        "positions": ["x", "x", "6", "4", "7", "6"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {"positions": ["4", "x", "4", "4", "4", "6"], "fingerings": [["2", "0", "3", "3", "3", "4"]]}],
    "G#m11": [{
        "positions": ["x", "11", "9", "11", "9", "9"],
        "fingerings": [["0", "3", "1", "4", "1", "1"]]
    }, {
        "positions": ["x", "11", "11", "11", "12", "11"],
        "fingerings": [["0", "1", "1", "1", "2", "1"]]
    }, {
        "positions": ["4", "x", "4", "4", "2", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "6", "7", "7"],
        "fingerings": [["0", "0", "1", "1", "2", "2"]]
    }, {"positions": ["x", "11", "x", "11", "12", "9"], "fingerings": [["0", "2", "0", "3", "4", "1"]]}],
    "G#m13": [{
        "positions": ["x", "11", "x", "11", "12", "13"],
        "fingerings": [["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["4", "6", "4", "4", "6", "4"],
        "fingerings": [["1", "3", "1", "1", "4", "1"]]
    }, {
        "positions": ["4", "x", "4", "4", "6", "6"],
        "fingerings": [["2", "0", "3", "3", "4", "4"], ["1", "0", "2", "3", "4", "4"]]
    }, {
        "positions": ["x", "11", "13", "11", "12", "13"],
        "fingerings": [["0", "1", "3", "1", "2", "4"]]
    }, {"positions": ["x", "11", "9", "11", "11", "13"], "fingerings": [["0", "2", "1", "3", "3", "4"]]}],
    "G#mMaj9": [{
        "positions": ["x", "11", "9", "12", "11", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {"positions": ["4", "6", "5", "4", "4", "6"], "fingerings": [["1", "3", "2", "1", "1", "4"]]}],
    "G#Maj9": [{
        "positions": ["x", "11", "10", "12", "11", "x"],
        "fingerings": [["0", "2", "1", "4", "3", "0"]]
    }, {
        "positions": ["x", "x", "6", "5", "8", "6"],
        "fingerings": [["0", "0", "2", "1", "4", "3"]]
    }, {
        "positions": ["x", "11", "8", "8", "8", "8"],
        "fingerings": [["0", "3", "1", "1", "1", "1"]]
    }, {
        "positions": ["4", "3", "5", "3", "4", "3"],
        "fingerings": [["2", "1", "4", "1", "3", "1"]]
    }, {"positions": ["4", "x", "5", "3", "4", "x"], "fingerings": [["2", "0", "4", "1", "3", "0"]]}],
    "G#Maj13": [{
        "positions": ["x", "11", "x", "12", "13", "13"],
        "fingerings": [["0", "1", "0", "2", "4", "4"], ["0", "1", "0", "2", "3", "4"]]
    }, {
        "positions": ["4", "3", "3", "3", "4", "3"],
        "fingerings": [["2", "1", "1", "1", "3", "1"]]
    }, {"positions": ["4", "x", "5", "5", "6", "6"], "fingerings": [["1", "0", "2", "3", "4", "4"]]}],
    "G#+9": [{
        "positions": ["x", "11", "10", "11", "11", "12"],
        "fingerings": [["0", "2", "1", "3", "3", "4"]]
    }, {"positions": ["4", "x", "4", "5", "5", "6"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}],
    "G#Maj7#11": [{
        "positions": ["x", "11", "12", "12", "13", "11"],
        "fingerings": [["0", "1", "2", "3", "4", "1"]]
    }, {
        "positions": ["4", "x", "5", "5", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "7", "8", "8"],
        "fingerings": [["0", "0", "1", "2", "3", "3"], ["0", "0", "1", "2", "3", "4"]]
    }],
    "G#9b5": [{
        "positions": ["x", "11", "10", "11", "11", "10"],
        "fingerings": [["0", "2", "1", "3", "4", "1"]]
    }, {"positions": ["4", "3", "4", "3", "3", "x"], "fingerings": [["2", "1", "3", "1", "1", "0"]]}],
    "G#7b9": [{
        "positions": ["x", "11", "10", "11", "10", "x"],
        "fingerings": [["0", "2", "1", "3", "1", "0"], ["0", "3", "1", "4", "2", "0"]]
    }, {
        "positions": ["4", "6", "4", "5", "4", "5"],
        "fingerings": [["1", "4", "1", "2", "1", "3"]]
    }, {
        "positions": ["x", "11", "10", "11", "10", "11"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["x", "x", "6", "5", "7", "5"], "fingerings": [["0", "0", "2", "1", "3", "1"]]}],
    "G#7#9": [{
        "positions": ["x", "11", "10", "11", "12", "x"],
        "fingerings": [["0", "2", "1", "3", "4", "0"]]
    }, {
        "positions": ["4", "6", "4", "5", "4", "7"],
        "fingerings": [["1", "3", "1", "2", "1", "4"]]
    }, {"positions": ["x", "x", "6", "5", "7", "7"], "fingerings": [["0", "0", "2", "1", "3", "4"]]}],
    "G#7b5#9": [{"positions": ["x", "11", "10", "11", "12", "10"], "fingerings": [["0", "2", "1", "3", "4", "1"]]}],
    "G#7#11": [{"positions": ["4", "5", "4", "5", "4", "4"], "fingerings": [["1", "2", "1", "3", "1", "1"]]}],
    "G#7b5": [{
        "positions": ["x", "11", "12", "11", "13", "x"],
        "fingerings": [["0", "1", "2", "1", "4", "0"]]
    }, {
        "positions": ["4", "x", "4", "5", "3", "x"],
        "fingerings": [["2", "0", "3", "4", "1", "0"]]
    }, {
        "positions": ["x", "x", "6", "7", "7", "8"],
        "fingerings": [["0", "0", "1", "2", "2", "3"], ["0", "0", "1", "2", "3", "4"]]
    }, {"positions": ["x", "11", "12", "11", "13", "14"], "fingerings": [["0", "1", "2", "1", "3", "4"]]}],
    "G#m9b5": [{"positions": ["4", "5", "4", "4", "7", "6"], "fingerings": [["1", "2", "1", "1", "4", "3"]]}],
    "G#+7b9": [{
        "positions": ["x", "11", "10", "11", "10", "12"],
        "fingerings": [["0", "2", "1", "3", "1", "4"]]
    }, {"positions": ["4", "x", "4", "5", "5", "5"], "fingerings": [["1", "0", "2", "3", "3", "3"]]}],
    "G#+7#9": [{
        "positions": ["x", "11", "10", "11", "12", "12"],
        "fingerings": [["0", "2", "1", "3", "4", "4"]]
    }, {"positions": ["4", "x", "4", "5", "5", "7"], "fingerings": [["1", "0", "2", "3", "3", "4"]]}]
}
